var _defs, _rect, _image, _path, _path2, _image2, _image3, _polygon, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon9, _path20, _polyline, _path21, _path22, _polygon10, _path23, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _polygon16, _polygon17, _polygon18, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _rect3, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _path51, _g2, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _polygon30, _polygon31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13H(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.57 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#231f20;}.cls-3{fill:#bc141a;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}.cls-17{fill:url(#linear-gradient-14);}.cls-18{fill:url(#linear-gradient-15);}.cls-19{fill:url(#linear-gradient-16);}.cls-20{fill:url(#linear-gradient-17);}.cls-21{fill:url(#linear-gradient-18);}.cls-22{clip-path:url(#clip-path);}.cls-23{fill:url(#linear-gradient-19);}.cls-24{fill:url(#linear-gradient-20);}.cls-25{fill:url(#linear-gradient-21);}.cls-26{fill:url(#linear-gradient-22);}.cls-27{fill:url(#linear-gradient-23);}.cls-28{fill:url(#linear-gradient-24);}.cls-29{fill:url(#linear-gradient-25);}.cls-30{fill:url(#linear-gradient-26);}.cls-31{fill:url(#linear-gradient-27);}.cls-32{fill:url(#linear-gradient-28);}.cls-33{fill:url(#linear-gradient-29);}.cls-34{fill:url(#linear-gradient-30);}.cls-35{fill:url(#linear-gradient-31);}.cls-36{fill:url(#linear-gradient-32);}.cls-37{fill:url(#linear-gradient-33);}.cls-38{fill:url(#linear-gradient-34);}.cls-39{fill:url(#linear-gradient-35);}.cls-40{fill:url(#linear-gradient-36);}.cls-41{fill:url(#linear-gradient-37);}.cls-42{fill:url(#linear-gradient-38);}.cls-43{fill:url(#linear-gradient-39);}.cls-44{fill:url(#linear-gradient-40);}.cls-45{fill:url(#linear-gradient-41);}.cls-46{fill:url(#linear-gradient-42);}.cls-47{fill:url(#linear-gradient-43);}.cls-48{fill:url(#linear-gradient-44);}.cls-49{fill:url(#linear-gradient-45);}.cls-50{fill:url(#linear-gradient-46);}.cls-51{fill:url(#linear-gradient-47);}.cls-52{fill:url(#linear-gradient-48);}.cls-53{fill:url(#linear-gradient-49);}.cls-54{fill:url(#linear-gradient-50);}.cls-55{fill:url(#linear-gradient-51);}.cls-56{fill:url(#linear-gradient-52);}.cls-57{fill:url(#linear-gradient-53);}.cls-58{fill:url(#linear-gradient-54);}.cls-59{fill:url(#linear-gradient-55);}.cls-60{fill:url(#linear-gradient-56);}.cls-61{fill:url(#linear-gradient-57);}.cls-62{fill:url(#linear-gradient-58);}.cls-63{fill:url(#linear-gradient-59);}.cls-64{fill:url(#linear-gradient-60);}.cls-65{fill:url(#linear-gradient-61);}.cls-66{fill:url(#linear-gradient-62);}.cls-67{fill:url(#linear-gradient-63);}.cls-68{fill:url(#linear-gradient-64);}.cls-69{fill:url(#linear-gradient-65);}.cls-70{fill:url(#linear-gradient-66);}.cls-71{fill:url(#linear-gradient-67);}.cls-72{fill:url(#linear-gradient-68);}.cls-73{fill:url(#linear-gradient-69);}.cls-74{fill:url(#linear-gradient-70);}.cls-75{fill:url(#linear-gradient-71);}.cls-76{fill:url(#linear-gradient-72);}.cls-77{fill:url(#linear-gradient-73);}.cls-78{fill:url(#linear-gradient-74);}.cls-79{fill:url(#linear-gradient-75);}.cls-80{fill:url(#linear-gradient-76);}.cls-81{fill:url(#linear-gradient-77);}.cls-82{fill:url(#linear-gradient-78);}.cls-83{fill:url(#linear-gradient-79);}.cls-84{fill:url(#linear-gradient-80);}.cls-85{fill:url(#linear-gradient-81);}.cls-86{fill:url(#linear-gradient-82);}.cls-87{fill:url(#linear-gradient-83);}.cls-88{fill:url(#linear-gradient-84);}.cls-89{fill:url(#linear-gradient-85);}.cls-90{fill:url(#linear-gradient-86);}.cls-91{fill:url(#linear-gradient-87);}.cls-92{fill:url(#linear-gradient-88);}.cls-93{fill:url(#linear-gradient-89);}.cls-94{fill:url(#linear-gradient-90);}.cls-95{fill:#fde4e0;}.cls-96{fill:#6b6c6f;}.cls-97{fill:url(#linear-gradient-91);}.cls-98{fill:url(#linear-gradient-92);}.cls-99{fill:#fab89d;}.cls-100{fill:url(#linear-gradient-93);}.cls-101{fill:url(#linear-gradient-94);}.cls-102{fill:url(#linear-gradient-95);}.cls-103{fill:url(#linear-gradient-96);}.cls-104{fill:url(#linear-gradient-97);}.cls-105{fill:#fff;}.cls-106{fill:url(#linear-gradient-98);}.cls-107{fill:url(#linear-gradient-99);}.cls-108{fill:url(#linear-gradient-100);}.cls-109{fill:#babcbe;}.cls-110{fill:url(#linear-gradient-101);}.cls-111{fill:url(#linear-gradient-102);}.cls-112{fill:url(#linear-gradient-103);}.cls-113{fill:url(#linear-gradient-104);}.cls-114{fill:url(#linear-gradient-105);}.cls-115{fill:url(#linear-gradient-106);}.cls-116{fill:url(#linear-gradient-107);}.cls-117{fill:url(#linear-gradient-108);}.cls-118{fill:url(#linear-gradient-109);}.cls-119{fill:url(#linear-gradient-110);}.cls-120{fill:url(#linear-gradient-111);}.cls-121{fill:url(#linear-gradient-112);}.cls-122{fill:url(#linear-gradient-113);}.cls-123{fill:url(#linear-gradient-114);}.cls-124{fill:url(#linear-gradient-115);}.cls-125{fill:url(#linear-gradient-116);}.cls-126{fill:url(#linear-gradient-117);}.cls-127{fill:url(#linear-gradient-118);}.cls-128{fill:url(#linear-gradient-119);}.cls-129{fill:url(#linear-gradient-120);}.cls-130{fill:url(#linear-gradient-121);}.cls-131{fill:url(#linear-gradient-122);}.cls-132{fill:url(#linear-gradient-123);}.cls-133{fill:url(#linear-gradient-124);}.cls-134{fill:url(#linear-gradient-125);}.cls-135{fill:url(#linear-gradient-126);}.cls-136{fill:url(#linear-gradient-127);}.cls-137{fill:url(#linear-gradient-128);}.cls-138{fill:url(#linear-gradient-129);}.cls-139{fill:url(#linear-gradient-130);}.cls-140{fill:url(#linear-gradient-131);}.cls-141{fill:url(#linear-gradient-132);}.cls-142{fill:url(#linear-gradient-133);}.cls-143{fill:url(#linear-gradient-134);}.cls-144{clip-path:url(#clip-path-2);}.cls-145{fill:url(#linear-gradient-135);}.cls-146{fill:url(#linear-gradient-136);}.cls-147{fill:url(#linear-gradient-137);}.cls-148{fill:url(#linear-gradient-138);}.cls-149{fill:url(#linear-gradient-139);}.cls-150{fill:url(#linear-gradient-140);}.cls-151{fill:url(#linear-gradient-141);}.cls-152{fill:url(#linear-gradient-142);}.cls-153{fill:url(#linear-gradient-143);}.cls-154{fill:url(#linear-gradient-144);}.cls-155{fill:url(#linear-gradient-145);}.cls-156{fill:url(#linear-gradient-146);}.cls-157{fill:url(#linear-gradient-147);}.cls-158{fill:url(#linear-gradient-148);}.cls-159{fill:url(#linear-gradient-149);}.cls-160{fill:url(#linear-gradient-150);}.cls-161{fill:url(#linear-gradient-151);}.cls-162{fill:url(#linear-gradient-152);}.cls-163{fill:url(#linear-gradient-153);}.cls-164{fill:url(#linear-gradient-154);}.cls-165{fill:url(#linear-gradient-155);}.cls-166{fill:url(#linear-gradient-156);}.cls-167{fill:url(#linear-gradient-157);}.cls-168{fill:url(#linear-gradient-158);}.cls-169{fill:url(#linear-gradient-159);}.cls-170{fill:url(#linear-gradient-160);}.cls-171{fill:url(#linear-gradient-161);}.cls-172{fill:url(#linear-gradient-162);}.cls-173{fill:url(#linear-gradient-163);}.cls-174{fill:url(#linear-gradient-164);}.cls-175{fill:url(#linear-gradient-165);}.cls-176{fill:url(#linear-gradient-166);}.cls-177{fill:url(#linear-gradient-167);}.cls-178{fill:url(#linear-gradient-168);}.cls-179{fill:url(#linear-gradient-169);}.cls-180{fill:url(#linear-gradient-170);}.cls-181{fill:url(#linear-gradient-171);}.cls-182{fill:url(#linear-gradient-172);}.cls-183{fill:url(#linear-gradient-173);}.cls-184{fill:url(#linear-gradient-174);}.cls-185{fill:url(#linear-gradient-175);}.cls-186{fill:url(#linear-gradient-176);}.cls-187{fill:url(#linear-gradient-177);}.cls-188{fill:url(#linear-gradient-178);}.cls-189{fill:url(#linear-gradient-179);}.cls-190{fill:url(#linear-gradient-180);}.cls-191{fill:url(#linear-gradient-181);}.cls-192{fill:url(#linear-gradient-182);}.cls-193{fill:url(#linear-gradient-183);}.cls-194{fill:url(#linear-gradient-184);}.cls-195{fill:url(#linear-gradient-185);}.cls-196{fill:url(#linear-gradient-186);}.cls-197{fill:url(#linear-gradient-187);}.cls-198{fill:url(#linear-gradient-188);}.cls-199{fill:url(#linear-gradient-189);}.cls-200{fill:url(#linear-gradient-190);}.cls-201{fill:url(#linear-gradient-191);}.cls-202{fill:url(#linear-gradient-192);}.cls-203{fill:url(#linear-gradient-193);}.cls-204{fill:url(#linear-gradient-194);}.cls-205{fill:url(#linear-gradient-195);}.cls-206{fill:url(#linear-gradient-196);}.cls-207{fill:url(#linear-gradient-197);}.cls-208{fill:url(#linear-gradient-198);}.cls-209{fill:url(#linear-gradient-199);}.cls-210{fill:url(#linear-gradient-200);}.cls-211{fill:url(#linear-gradient-201);}.cls-212{fill:url(#linear-gradient-202);}.cls-213{fill:url(#linear-gradient-203);}.cls-214{fill:url(#linear-gradient-204);}.cls-215{fill:url(#linear-gradient-205);}.cls-216{fill:url(#linear-gradient-206);}.cls-217{fill:url(#linear-gradient-207);}.cls-218{fill:url(#linear-gradient-208);}.cls-219{fill:url(#linear-gradient-209);}.cls-220{fill:url(#linear-gradient-210);}.cls-221{fill:url(#linear-gradient-211);}.cls-222{fill:url(#linear-gradient-212);}.cls-223{fill:url(#linear-gradient-213);}.cls-224{fill:url(#linear-gradient-214);}.cls-225{fill:url(#linear-gradient-215);}.cls-226{fill:url(#linear-gradient-216);}.cls-227{fill:url(#linear-gradient-217);}.cls-228{fill:url(#linear-gradient-218);}.cls-229{fill:url(#linear-gradient-219);}.cls-230{fill:url(#linear-gradient-220);}.cls-231{fill:url(#linear-gradient-221);}.cls-232{fill:url(#linear-gradient-222);}.cls-233{fill:url(#linear-gradient-223);}.cls-234{fill:url(#linear-gradient-224);}.cls-235{fill:url(#linear-gradient-225);}.cls-236{fill:url(#linear-gradient-226);}.cls-237{fill:url(#linear-gradient-227);}.cls-238{fill:url(#linear-gradient-228);}.cls-239{fill:url(#linear-gradient-229);}.cls-240{fill:url(#linear-gradient-230);}.cls-241{fill:url(#linear-gradient-231);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.11,
    y1: 46.29,
    x2: 41.76,
    y2: 54.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d5d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 477.23,
    y1: 113.69,
    x2: 486,
    y2: 121.51,
    gradientTransform: "matrix(-0.95, -0.3, -0.3, 0.95, 548.78, 86.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.47,
    y1: 83.99,
    x2: 55.65,
    y2: 83.99,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 52.66,
    y1: 74.58,
    x2: 53.54,
    y2: 86.08,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 49.29,
    y1: 82.87,
    x2: 47.11,
    y2: 83.85,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 53.28,
    y1: 81.46,
    x2: 59.99,
    y2: 81.46,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 59.72,
    y1: 82.04,
    x2: 50.27,
    y2: 86.28,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 54.31,
    y1: 85.51,
    x2: 50.6,
    y2: 88.3,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 47.95,
    y1: 76.06,
    x2: 52.09,
    y2: 76.06,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 46.86,
    y1: 74.17,
    x2: 50.69,
    y2: 77.58,
    gradientTransform: "translate(2.94 -32.83) rotate(7.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 32.11,
    y1: 96.44,
    x2: 59.82,
    y2: 121.16,
    gradientTransform: "translate(156.69 34.89) rotate(90.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec1c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f181b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 50.35,
    y1: 46.79,
    x2: 54.57,
    y2: 50.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 50.82,
    y1: 56.35,
    x2: 53.52,
    y2: 58.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 35.91,
    y1: 45.92,
    x2: 39.17,
    y2: 48.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 33.74,
    y1: 52.67,
    x2: 38.3,
    y2: 56.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 53.83,
    y1: 52.02,
    x2: 56.91,
    y2: 54.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 33.1,
    y1: 49.26,
    x2: 35.99,
    y2: 51.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 53.9,
    y1: 52.82,
    x2: 64.23,
    y2: 67.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.18,65.64,127.55,71s5.61.53,5.61,7.23v25.71l-99.6,11.53S58.68,78,66.52,71.26c.87-.75,4.91-1.63,9.87-2.48C86.05,67.13,99.18,65.64,99.18,65.64Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 74.9,
    y1: 55.53,
    x2: 16.62,
    y2: 133.42,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 81.84,
    y1: 60.72,
    x2: 23.56,
    y2: 138.62,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 88.78,
    y1: 65.92,
    x2: 30.49,
    y2: 143.82,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 95.72,
    y1: 71.11,
    x2: 37.44,
    y2: 149.01,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 102.66,
    y1: 76.3,
    x2: 44.38,
    y2: 154.2,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 109.6,
    y1: 81.5,
    x2: 51.32,
    y2: 159.39,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 116.54,
    y1: 86.69,
    x2: 58.26,
    y2: 164.58,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 123.48,
    y1: 91.88,
    x2: 65.2,
    y2: 169.78,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 130.43,
    y1: 97.08,
    x2: 72.14,
    y2: 174.98,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 133.65,
    y1: 99.49,
    x2: 75.37,
    y2: 177.39,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 126.71,
    y1: 94.3,
    x2: 68.43,
    y2: 172.19,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 119.77,
    y1: 89.11,
    x2: 61.49,
    y2: 167,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 112.83,
    y1: 83.91,
    x2: 54.55,
    y2: 161.81,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 105.89,
    y1: 78.72,
    x2: 47.61,
    y2: 156.61,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 98.95,
    y1: 73.53,
    x2: 40.67,
    y2: 151.42,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 92.01,
    y1: 68.33,
    x2: 33.72,
    y2: 146.23,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 85.07,
    y1: 63.14,
    x2: 26.78,
    y2: 141.03,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 78.13,
    y1: 57.95,
    x2: 19.84,
    y2: 135.84,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 63.63,
    y1: 47.1,
    x2: 5.35,
    y2: 125,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 70.57,
    y1: 52.29,
    x2: 12.29,
    y2: 130.19,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 77.52,
    y1: 57.49,
    x2: 19.23,
    y2: 135.38,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 84.46,
    y1: 62.68,
    x2: 26.17,
    y2: 140.58,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 91.4,
    y1: 67.87,
    x2: 33.11,
    y2: 145.77,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 98.34,
    y1: 73.07,
    x2: 40.05,
    y2: 150.96,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 105.28,
    y1: 78.26,
    x2: 46.99,
    y2: 156.16,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 112.22,
    y1: 83.45,
    x2: 53.93,
    y2: 161.35,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 119.16,
    y1: 88.64,
    x2: 60.88,
    y2: 166.54,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 122.39,
    y1: 91.06,
    x2: 64.1,
    y2: 168.96,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 115.45,
    y1: 85.87,
    x2: 57.16,
    y2: 163.76,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 108.51,
    y1: 80.67,
    x2: 50.22,
    y2: 158.57,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 101.57,
    y1: 75.48,
    x2: 43.28,
    y2: 153.38,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 94.63,
    y1: 70.29,
    x2: 36.34,
    y2: 148.19,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 87.68,
    y1: 65.1,
    x2: 29.4,
    y2: 142.99,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 80.74,
    y1: 59.9,
    x2: 22.46,
    y2: 137.8,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 73.8,
    y1: 54.71,
    x2: 15.52,
    y2: 132.6,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 66.86,
    y1: 49.52,
    x2: 8.58,
    y2: 127.41,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 95.81,
    y1: 71.17,
    x2: 37.52,
    y2: 149.07,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 102.74,
    y1: 76.37,
    x2: 44.46,
    y2: 154.26,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 109.69,
    y1: 81.56,
    x2: 51.4,
    y2: 159.46,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 116.63,
    y1: 86.75,
    x2: 58.34,
    y2: 164.65,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 123.57,
    y1: 91.94,
    x2: 65.28,
    y2: 169.84,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 130.51,
    y1: 97.14,
    x2: 72.22,
    y2: 175.04,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 137.45,
    y1: 102.33,
    x2: 79.17,
    y2: 180.22,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 144.39,
    y1: 107.53,
    x2: 86.1,
    y2: 185.42,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 151.33,
    y1: 112.72,
    x2: 93.04,
    y2: 190.62,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 154.56,
    y1: 115.13,
    x2: 96.27,
    y2: 193.04,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 147.62,
    y1: 109.94,
    x2: 89.33,
    y2: 187.84,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 140.68,
    y1: 104.75,
    x2: 82.39,
    y2: 182.64,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 133.74,
    y1: 99.55,
    x2: 75.45,
    y2: 177.45,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 126.8,
    y1: 94.36,
    x2: 68.51,
    y2: 172.26,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 119.86,
    y1: 89.17,
    x2: 61.57,
    y2: 167.06,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 112.92,
    y1: 83.97,
    x2: 54.63,
    y2: 161.87,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 105.97,
    y1: 78.78,
    x2: 47.69,
    y2: 156.68,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 99.03,
    y1: 73.59,
    x2: 40.75,
    y2: 151.48,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 84.54,
    y1: 62.74,
    x2: 26.25,
    y2: 140.64,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 91.48,
    y1: 67.93,
    x2: 33.19,
    y2: 145.83,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 98.42,
    y1: 73.13,
    x2: 40.13,
    y2: 151.02,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 105.36,
    y1: 78.32,
    x2: 47.07,
    y2: 156.22,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 112.3,
    y1: 83.51,
    x2: 54.01,
    y2: 161.41,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 119.24,
    y1: 88.71,
    x2: 60.95,
    y2: 166.61,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 126.18,
    y1: 93.9,
    x2: 67.89,
    y2: 171.8,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 133.12,
    y1: 99.09,
    x2: 74.83,
    y2: 176.99,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 140.06,
    y1: 104.29,
    x2: 81.78,
    y2: 182.19,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 143.29,
    y1: 106.7,
    x2: 85.01,
    y2: 184.6,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 136.35,
    y1: 101.51,
    x2: 78.07,
    y2: 179.41,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 129.41,
    y1: 96.31,
    x2: 71.12,
    y2: 174.22,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 122.47,
    y1: 91.12,
    x2: 64.18,
    y2: 169.03,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 115.53,
    y1: 85.93,
    x2: 57.24,
    y2: 163.83,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 108.59,
    y1: 80.74,
    x2: 50.3,
    y2: 158.63,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 101.65,
    y1: 75.54,
    x2: 43.36,
    y2: 153.44,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 94.72,
    y1: 70.34,
    x2: 36.42,
    y2: 148.25,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 87.77,
    y1: 65.15,
    x2: 29.48,
    y2: 143.06,
    gradientTransform: "translate(6.04 -23.63) rotate(9.43)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 91.29,
    y1: 29.73,
    x2: 102.94,
    y2: 62.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 142.27,
    y1: 21.27,
    x2: 59.66,
    y2: 33.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 70.29,
    y1: 62.81,
    x2: 112.79,
    y2: 78.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 143.85,
    y1: 12.28,
    x2: 55.84,
    y2: 25.21,
    gradientTransform: "matrix(0.99, 0.01, -0.01, 1.02, 2.78, -2.99)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 75.12,
    y1: 13.72,
    x2: 75.49,
    y2: 20.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 98.82,
    y1: 16.8,
    x2: 99.21,
    y2: 23.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 84.78,
    y1: 15.04,
    x2: 83.7,
    y2: 10.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 80.08,
    y1: 87.47,
    x2: 123.2,
    y2: 87.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 33.06,
    y1: 101.32,
    x2: 94.58,
    y2: 101.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 33.06,
    y1: 101.32,
    x2: 59.83,
    y2: 101.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 76.41,
    y1: 112.39,
    x2: 108.75,
    y2: 79.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 76.52,
    y1: 112.49,
    x2: 108.85,
    y2: 79.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 76.62,
    y1: 112.58,
    x2: 108.95,
    y2: 79.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 76.72,
    y1: 112.68,
    x2: 109.05,
    y2: 79.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 76.82,
    y1: 112.78,
    x2: 109.15,
    y2: 79.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 76.92,
    y1: 112.88,
    x2: 109.25,
    y2: 79.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 77.02,
    y1: 112.98,
    x2: 109.35,
    y2: 79.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 16.33,
    y1: 77.93,
    x2: 45.83,
    y2: 38.76,
    gradientTransform: "matrix(0.94, -0.16, 0.16, 0.97, 9.67, 43.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 16.89,
    y1: 78.35,
    x2: 46.39,
    y2: 39.18,
    gradientTransform: "matrix(0.94, -0.16, 0.16, 0.97, 9.67, 43.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 17.45,
    y1: 78.77,
    x2: 46.95,
    y2: 39.6,
    gradientTransform: "matrix(0.94, -0.16, 0.16, 0.97, 9.67, 43.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 18.01,
    y1: 79.19,
    x2: 47.52,
    y2: 40.02,
    gradientTransform: "matrix(0.94, -0.16, 0.16, 0.97, 9.67, 43.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 18.57,
    y1: 79.61,
    x2: 48.07,
    y2: 40.45,
    gradientTransform: "matrix(0.94, -0.16, 0.16, 0.97, 9.67, 43.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 19.13,
    y1: 80.03,
    x2: 48.63,
    y2: 40.87,
    gradientTransform: "matrix(0.94, -0.16, 0.16, 0.97, 9.67, 43.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 19.7,
    y1: 80.45,
    x2: 49.19,
    y2: 41.29,
    gradientTransform: "matrix(0.94, -0.16, 0.16, 0.97, 9.67, 43.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 73.7,
    y1: 56.72,
    x2: 80.97,
    y2: 56.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 72.33,
    y1: 47.31,
    x2: 77.08,
    y2: 47.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 482.74,
    y1: -75.93,
    x2: 491.4,
    y2: -68.22,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 85.93,
    y1: -139.28,
    x2: 94.7,
    y2: -131.45,
    gradientTransform: "matrix(0.95, 0.3, 0.3, -0.95, 67.34, 10.59)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 477.68,
    y1: -92.57,
    x2: 486.86,
    y2: -92.57,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 483.87,
    y1: -101.98,
    x2: 484.75,
    y2: -90.48,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 480.5,
    y1: -93.69,
    x2: 478.32,
    y2: -92.71,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 484.49,
    y1: -95.11,
    x2: 491.2,
    y2: -95.11,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 490.93,
    y1: -94.52,
    x2: 481.48,
    y2: -90.29,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 485.52,
    y1: -91.05,
    x2: 481.81,
    y2: -88.26,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 479.16,
    y1: -100.5,
    x2: 483.3,
    y2: -100.5,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 478.07,
    y1: -102.39,
    x2: 481.9,
    y2: -98.98,
    gradientTransform: "translate(613.18 130.09) rotate(-172.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 463.32,
    y1: -80.12,
    x2: 491.03,
    y2: -55.4,
    gradientTransform: "matrix(0, -1, 1, 0, 186.33, 615.81)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 499.98,
    y1: -75.43,
    x2: 504.2,
    y2: -71.66,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 500.45,
    y1: -65.87,
    x2: 503.15,
    y2: -63.46,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 485.54,
    y1: -76.31,
    x2: 488.81,
    y2: -73.39,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 483.38,
    y1: -69.56,
    x2: 487.94,
    y2: -65.49,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 503.46,
    y1: -70.2,
    x2: 506.54,
    y2: -67.46,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 482.74,
    y1: -72.97,
    x2: 485.62,
    y2: -70.4,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 503.53,
    y1: -69.41,
    x2: 513.87,
    y2: -54.41,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.31,153.84l-28.37-5.36s-5.61-.53-5.61-7.23V115.54L132.93,104s-25.12,37.5-33,44.2c-.87.75-4.91,1.64-9.87,2.48C80.44,152.35,67.31,153.84,67.31,153.84Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 498.44,
    y1: -138.69,
    x2: 440.15,
    y2: -60.8,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 505.38,
    y1: -133.5,
    x2: 447.09,
    y2: -55.6,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 512.32,
    y1: -128.31,
    x2: 454.03,
    y2: -50.41,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 519.26,
    y1: -123.11,
    x2: 460.97,
    y2: -45.22,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 526.2,
    y1: -117.92,
    x2: 467.92,
    y2: -40.03,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 533.14,
    y1: -112.73,
    x2: 474.86,
    y2: -34.83,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 540.08,
    y1: -107.53,
    x2: 481.8,
    y2: -29.64,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 547.02,
    y1: -102.34,
    x2: 488.73,
    y2: -24.44,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 553.96,
    y1: -97.15,
    x2: 495.67,
    y2: -19.25,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 557.19,
    y1: -94.73,
    x2: 498.91,
    y2: -16.83,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 550.25,
    y1: -99.92,
    x2: 491.97,
    y2: -22.03,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 543.31,
    y1: -105.12,
    x2: 485.02,
    y2: -27.22,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 536.37,
    y1: -110.31,
    x2: 478.08,
    y2: -32.42,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 529.43,
    y1: -115.5,
    x2: 471.15,
    y2: -37.61,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 522.49,
    y1: -120.7,
    x2: 464.2,
    y2: -42.8,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 515.55,
    y1: -125.89,
    x2: 457.26,
    y2: -47.99,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 508.61,
    y1: -131.08,
    x2: 450.32,
    y2: -53.19,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 501.67,
    y1: -136.28,
    x2: 443.38,
    y2: -58.38,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 487.17,
    y1: -147.12,
    x2: 428.88,
    y2: -69.23,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 494.11,
    y1: -141.93,
    x2: 435.83,
    y2: -64.04,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 501.05,
    y1: -136.74,
    x2: 442.77,
    y2: -58.85,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 507.99,
    y1: -131.54,
    x2: 449.71,
    y2: -53.65,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 514.93,
    y1: -126.35,
    x2: 456.65,
    y2: -48.45,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 521.87,
    y1: -121.16,
    x2: 463.59,
    y2: -43.26,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 528.81,
    y1: -115.96,
    x2: 470.53,
    y2: -38.07,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 535.76,
    y1: -110.77,
    x2: 477.47,
    y2: -32.87,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 542.7,
    y1: -105.58,
    x2: 484.41,
    y2: -27.68,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 545.92,
    y1: -103.16,
    x2: 487.64,
    y2: -25.26,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 538.98,
    y1: -108.35,
    x2: 480.7,
    y2: -30.46,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 532.04,
    y1: -113.55,
    x2: 473.76,
    y2: -35.65,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 525.1,
    y1: -118.74,
    x2: 466.81,
    y2: -40.84,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 518.16,
    y1: -123.93,
    x2: 459.87,
    y2: -46.03,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 511.22,
    y1: -129.13,
    x2: 452.94,
    y2: -51.24,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 504.28,
    y1: -134.32,
    x2: 446,
    y2: -56.43,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 497.34,
    y1: -139.51,
    x2: 439.05,
    y2: -61.62,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 490.4,
    y1: -144.71,
    x2: 432.11,
    y2: -66.81,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 519.35,
    y1: -123.06,
    x2: 461.05,
    y2: -45.15,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 526.28,
    y1: -117.86,
    x2: 468,
    y2: -39.96,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 533.22,
    y1: -112.67,
    x2: 474.94,
    y2: -34.77,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 540.17,
    y1: -107.48,
    x2: 481.87,
    y2: -29.57,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 547.11,
    y1: -102.28,
    x2: 488.81,
    y2: -24.38,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 554.04,
    y1: -97.08,
    x2: 495.76,
    y2: -19.19,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 560.98,
    y1: -91.89,
    x2: 502.7,
    y2: -14,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 567.93,
    y1: -86.7,
    x2: 509.64,
    y2: -8.8,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 574.87,
    y1: -81.5,
    x2: 516.58,
    y2: -3.6,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 578.1,
    y1: -79.09,
    x2: 519.81,
    y2: -1.19,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 571.15,
    y1: -84.28,
    x2: 512.87,
    y2: -6.39,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 564.21,
    y1: -89.47,
    x2: 505.93,
    y2: -11.58,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 557.27,
    y1: -94.67,
    x2: 498.99,
    y2: -16.77,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 550.33,
    y1: -99.86,
    x2: 492.05,
    y2: -21.96,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 543.39,
    y1: -105.05,
    x2: 485.11,
    y2: -27.16,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 536.45,
    y1: -110.25,
    x2: 478.17,
    y2: -32.35,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 529.51,
    y1: -115.44,
    x2: 471.23,
    y2: -37.54,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 522.57,
    y1: -120.64,
    x2: 464.28,
    y2: -42.74,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 508.08,
    y1: -131.48,
    x2: 449.79,
    y2: -53.58,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 515.01,
    y1: -126.29,
    x2: 456.73,
    y2: -48.39,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 521.96,
    y1: -121.1,
    x2: 463.67,
    y2: -43.2,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 528.9,
    y1: -115.9,
    x2: 470.61,
    y2: -38,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 535.84,
    y1: -110.71,
    x2: 477.55,
    y2: -32.81,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 542.78,
    y1: -105.51,
    x2: 484.49,
    y2: -27.62,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 549.72,
    y1: -100.32,
    x2: 491.43,
    y2: -22.42,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 556.66,
    y1: -95.13,
    x2: 498.37,
    y2: -17.24,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 563.6,
    y1: -89.93,
    x2: 505.32,
    y2: -12.04,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 566.83,
    y1: -87.52,
    x2: 508.54,
    y2: -9.62,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 559.89,
    y1: -92.71,
    x2: 501.6,
    y2: -14.82,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 552.95,
    y1: -97.91,
    x2: 494.66,
    y2: -20.01,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 546.01,
    y1: -103.1,
    x2: 487.72,
    y2: -25.2,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 539.07,
    y1: -108.29,
    x2: 480.78,
    y2: -30.4,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 532.12,
    y1: -113.48,
    x2: 473.84,
    y2: -35.59,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 525.19,
    y1: -118.68,
    x2: 466.9,
    y2: -40.78,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 518.25,
    y1: -123.88,
    x2: 459.96,
    y2: -45.97,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 511.31,
    y1: -129.07,
    x2: 453.02,
    y2: -51.17,
    gradientTransform: "translate(610.09 120.89) rotate(-170.57)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 540.92,
    y1: -92.5,
    x2: 552.57,
    y2: -59.58,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 573.18,
    y1: -106.58,
    x2: 530.93,
    y2: -99.08,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 591.9,
    y1: -100.95,
    x2: 509.3,
    y2: -88.82,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 541.55,
    y1: -102.82,
    x2: 514.33,
    y2: -98.82,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 579.58,
    y1: -110.75,
    x2: 535.51,
    y2: -104.28,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 519.92,
    y1: -59.42,
    x2: 562.42,
    y2: -43.42,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 529.71,
    y1: -34.75,
    x2: 572.83,
    y2: -34.75,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 482.7,
    y1: -20.9,
    x2: 544.21,
    y2: -20.9,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 482.7,
    y1: -20.9,
    x2: 509.46,
    y2: -20.9,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 526.05,
    y1: -9.84,
    x2: 558.38,
    y2: -43,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 526.15,
    y1: -9.74,
    x2: 558.48,
    y2: -42.9,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 526.25,
    y1: -9.64,
    x2: 558.58,
    y2: -42.81,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 526.35,
    y1: -9.54,
    x2: 558.68,
    y2: -42.71,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 526.45,
    y1: -9.45,
    x2: 558.78,
    y2: -42.61,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 526.55,
    y1: -9.35,
    x2: 558.88,
    y2: -42.51,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 526.65,
    y1: -9.25,
    x2: 558.98,
    y2: -42.42,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 502.39,
    y1: 30.05,
    x2: 531.89,
    y2: -9.12,
    gradientTransform: "matrix(-0.94, 0.16, -0.16, -0.97, 606.45, 53.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 502.95,
    y1: 30.47,
    x2: 532.45,
    y2: -8.69,
    gradientTransform: "matrix(-0.94, 0.16, -0.16, -0.97, 606.45, 53.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 503.51,
    y1: 30.89,
    x2: 533.01,
    y2: -8.27,
    gradientTransform: "matrix(-0.94, 0.16, -0.16, -0.97, 606.45, 53.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 504.07,
    y1: 31.32,
    x2: 533.57,
    y2: -7.85,
    gradientTransform: "matrix(-0.94, 0.16, -0.16, -0.97, 606.45, 53.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 504.63,
    y1: 31.74,
    x2: 534.13,
    y2: -7.43,
    gradientTransform: "matrix(-0.94, 0.16, -0.16, -0.97, 606.45, 53.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 505.19,
    y1: 32.16,
    x2: 534.69,
    y2: -7.01,
    gradientTransform: "matrix(-0.94, 0.16, -0.16, -0.97, 606.45, 53.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 505.75,
    y1: 32.58,
    x2: 535.25,
    y2: -6.59,
    gradientTransform: "matrix(-0.94, 0.16, -0.16, -0.97, 606.45, 53.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 523.33,
    y1: -65.5,
    x2: 530.6,
    y2: -65.5,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 521.96,
    y1: -74.92,
    x2: 526.71,
    y2: -74.92,
    gradientTransform: "translate(616.12 97.26) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1901.82,
    y: -519.25,
    width: 2406.31,
    height: 1210.9
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(6.64 1.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACcElEQVR4Xu3WMQqEMABFwUT2/lfOVgqKsAv6upnOaPn4ca61xo3bQ/jDvB58Ls/i4qm9oSO27eYlvOHoaY9MYBTWGOclg8Q2rBitZcnIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYzcNsaYvz6CB6YlI7dHZs0ozDHO/2RC401HT9frUmi84dTRFxMoDbIIDQHrAAAAAElFTkSuQmCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.43,21.82l8.06,8a15.11,15.11,0,0,0,3.39,2.7,7.13,7.13,0,0,0,2.81.81V34H26.29v-.6A2.22,2.22,0,0,0,27.63,33a.88.88,0,0,0,.41-.7,1.6,1.6,0,0,0-.15-.7,6.3,6.3,0,0,0-1-1.14L19.34,23v7a7.17,7.17,0,0,0,.21,2.19,1.39,1.39,0,0,0,.67.69,2.94,2.94,0,0,0,1.47.39h.74V34H13.11v-.6h.78a2.32,2.32,0,0,0,2-.79,4.86,4.86,0,0,0,.39-2.48V16A7.47,7.47,0,0,0,16,13.74a1.46,1.46,0,0,0-.66-.67,3,3,0,0,0-1.48-.39h-.78v-.6h9.32v.6h-.74a3.11,3.11,0,0,0-1.47.37,1.41,1.41,0,0,0-.69.77A7.44,7.44,0,0,0,19.34,16v6.69l2.21-2a48,48,0,0,0,5.78-5.86,2.11,2.11,0,0,0,.44-1.13.83.83,0,0,0-.34-.65,1.78,1.78,0,0,0-1.14-.28h-.5v-.6h8v.6a4.61,4.61,0,0,0-1.29.19,6.65,6.65,0,0,0-1.42.69A14.14,14.14,0,0,0,29,15.19q-.34.33-3.27,3.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.06,197.66l-8.07-8a14.88,14.88,0,0,0-3.38-2.7,7.13,7.13,0,0,0-2.81-.81v-.6h10.4v.6a2.22,2.22,0,0,0-1.34.31.89.89,0,0,0-.42.7,1.47,1.47,0,0,0,.16.7,6.3,6.3,0,0,0,1,1.14l7.54,7.47v-7a7.17,7.17,0,0,0-.21-2.19,1.39,1.39,0,0,0-.67-.69,3,3,0,0,0-1.47-.39h-.74v-.6h9.32v.6h-.78a2.3,2.3,0,0,0-2,.79,4.86,4.86,0,0,0-.39,2.48v14.13a7.42,7.42,0,0,0,.21,2.21,1.53,1.53,0,0,0,.66.68,3.13,3.13,0,0,0,1.48.38h.78v.6h-9.32v-.6h.74a3.14,3.14,0,0,0,1.47-.37,1.41,1.41,0,0,0,.69-.77,7.44,7.44,0,0,0,.19-2.13v-6.69l-2.21,2a49.26,49.26,0,0,0-5.79,5.86,2.08,2.08,0,0,0-.43,1.13.83.83,0,0,0,.34.65,1.76,1.76,0,0,0,1.14.28h.5v.6h-8v-.6a4.72,4.72,0,0,0,1.29-.19,6.65,6.65,0,0,0,1.42-.69,13,13,0,0,0,2.06-1.63q.36-.33,3.28-3.31Z"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 15,
    transform: "translate(17.64 39.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAACXBIWXMAAAsSAAALEgHS3X78AAABhElEQVQoU22Sy24TQRBFT1V3z4wtHBBIYCEjdkj8ABIkn2/Y5AsiseBhhYQggcf2PHpmuliMJyDM2fSiq+6V7i0xMwDWy5WJKufXX4S/WC9XBnBxsxEAMTM+rF6ayz0cR7t9C0B2VtBXEVEhdYnzb19F1suV+XnAzzLEK5YSQ92TPyowg9QN9FWk20fMDK9BR1n584RFjnhFDGZPH9D8OABCX0f8EAf8LMPPAhoU9Y7uEJk/W5C6RFjk2JBIfSLuGjyAqKBe8fMM9YqbBdJgFE/mmBkaHOqV7KwYF1I/gMhx0eEKj2YO9Y7qdkf7q8bMiOXRIe5axCk2JLKHBWGRo8HR1REwqtsdLvcA6JTvlAbAGI/RlQ2xbLFkxG3Nxc1GFMZSUp8Qp+OAGe224XBdUn3foUF5txkLPWYKbz9/krhtQCBuW0SgvtuTusSbq4/37ct0GhOXr19Z8XhOfbcnls39SUwo/9D+rBjanlg2qDv5PnUAeP/8hVmyE3X4jwOApVORid+nAM3EDzZ3RgAAAABJRU5ErkJggg=="
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 14,
    transform: "translate(136.64 166.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAAsSAAALEgHS3X78AAABaElEQVQoU2WS3ZISMRBGTyeZSUAG2L1QxGGRx7D08WH1LXYttdQbS9cfdpik2wtqqILNTVe6c/qr/jpiZlye2/bGNCvvvn2Wy5p78howg2Z9xW5586RbuEzsliszNVxwxKvRZflc4f36tYkTJqs58XoMwIfN5kzlBOxerswFh6s8k1czfB2O4HzEbbs+QSfAx8Cz5Yzxi4Z6mvAp4GPAiuKjZ7to7QQMF1Oj2VyDCNgxVE3Cx4A4YbtoLWwXrdWzRD1NxHkipAoRoTz2mEEYV1hJmBrdz/3RpTgbMXo+IaQKzQURof/XAwZmiBNEjisJIVXkfQ9mmBpln9Fc2H//TTWJaC6YGcPUQftC//eAZkXLAXGCrz1WlNJlSpcRJ5Qu42tP0KJYl3m4+0HdRMQ5JAh/vvyiGte46HHBgxogiJmxXbTmKs+wh8PD4+A29TQBoIdyVBs+32Ctj4E3H+/lLFd5NCtvv36S/6MHnEv/ZhfwAAAAAElFTkSuQmCC"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "42.49 47.68 35.83 47.68 34.33 54.35 41.66 58.68 42.49 47.68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.07 48.56 56.51 50.61 55.91 57.51 47.49 59.44 50.07 48.56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.05,50.61S36.69,55,42.59,59.46l-.37,3,4.93.61.54-4.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41,56.15a6.07,6.07,0,1,0-1.17-4.89A6.08,6.08,0,0,0,41,56.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.07,50.82s-2.65,4.57,2.52,8.64l-.06.88S36.17,55.81,40.07,50.82Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.18,59.58s1.25-3.39,4.4-3.62,1.77-5.82,1.77-5.82S56.6,59,45.18,59.58Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.18,59.58s4.18.67,6.55-2.47c0,0-6.81,5-11.47-1.48,0,0,1.45,2.94,3.89,3.87L44,62l.77.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M46.86,58.22s.31-1.68,3.69-1.67A3.73,3.73,0,0,1,46.86,58.22Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M43.81,46.71a1.91,1.91,0,0,0-2.59,1.55,6.45,6.45,0,0,0,3.8,3S42,48.77,43.81,46.71Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M41.22,48.26s0,2.44,3.59,2.94c0,0-4.37-2.52-2.8-4.3C42,46.9,41.26,47.07,41.22,48.26Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 16.05,
    y: 85.65,
    width: 50.91,
    height: 4.7,
    transform: "translate(-50.92 118.38) rotate(-82.95)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "50.59 48.69 55.24 52.02 56.51 50.61 50.59 48.69"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "49.83 58.85 54.41 56.35 55.91 57.51 49.83 58.85"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "35.83 47.68 36.58 49.43 41.22 48.26 41.24 47.77 35.83 47.68"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "34.33 54.35 35.91 53.43 39.74 57.52 34.33 54.35"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "55.24 52.02 54.41 56.35 55.91 57.51 56.51 50.61 55.24 52.02"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "35.83 47.68 34.33 54.35 35.91 53.43 36.58 49.43 35.83 47.68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M99.18,65.75l28.37,5.36s5.61.54,5.61,7.23v25.72l-99.6,11.52s25.12-37.5,33-44.2c.87-.75,4.91-1.64,9.87-2.48C86.05,67.25,99.18,65.75,99.18,65.75Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.13,71.71a7.63,7.63,0,0,1,.77,2,5.4,5.4,0,0,1,.1.58c0,.16,0,.23.09.24h0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.73,3.73,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.66,3.66,0,0,0-1.2,3.1C41.73,68.57,43.15,69.9,44.13,71.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M54.81,73.48a7.7,7.7,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.25l0,0,0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86C59,72.42,60.75,71.57,61.4,70a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.44-1,2.22,2.22,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.67,3.67,0,0,0-1.2,3.11C52.41,70.34,53.83,71.67,54.81,73.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M65.49,75.26a7.63,7.63,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16,0,.24.09.25l0,0s0,0,0,0,.27-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.67,3.67,0,0,0-1.2,3.11C63.09,72.12,64.51,73.44,65.49,75.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M76.17,77a7.57,7.57,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57c0,.16,0,.23.09.24h0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.73,3.73,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.69,3.69,0,0,0-1.2,3.1C73.77,73.89,75.19,75.22,76.17,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M86.85,78.8a7.7,7.7,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.27-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.46,3.2-2.31,3.85-3.88A3.7,3.7,0,0,0,93.18,72a2.07,2.07,0,0,0-1.44-1,2.22,2.22,0,0,0-2,.81A3.85,3.85,0,0,0,89.1,73a2.62,2.62,0,0,0-1.95-2.64,2.1,2.1,0,0,0-1.67.54A3.67,3.67,0,0,0,84.28,74C84.45,75.67,85.87,77,86.85,78.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M97.53,80.58a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25l0,0,0,0c.11,0,.27-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.08,2.08,0,0,0-1.66.53A3.7,3.7,0,0,0,95,75.75C95.13,77.44,96.55,78.76,97.53,80.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M108.21,82.35a7.57,7.57,0,0,1,.77,2c0,.18.08.37.11.57s0,.23.08.24h0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.73,3.73,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.69,3.69,0,0,0-1.2,3.1C105.81,79.21,107.23,80.54,108.21,82.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M118.89,84.12a7.7,7.7,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.47.32-.55a7.57,7.57,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.05,2.05,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.64,2.13,2.13,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C116.49,81,117.91,82.31,118.89,84.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M129.57,85.9a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s.05.24.08.25,0,0,0,0,0,0,0,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.61,2.61,0,0,0-1.95-2.63,2.09,2.09,0,0,0-1.67.53,3.7,3.7,0,0,0-1.2,3.11C127.17,82.76,128.59,84.08,129.57,85.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M127.13,88.38a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.17-.05-.24-.09-.25l0,0s0,0,0,0-.27.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C129.53,91.52,128.11,90.2,127.13,88.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M116.45,86.61a7.57,7.57,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57c0-.16,0-.23-.09-.24s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.73,3.73,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.66,3.66,0,0,0,1.2-3.1C118.85,89.75,117.43,88.43,116.45,86.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M105.77,84.83a7.5,7.5,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57c0-.16-.05-.24-.09-.25l0,0,0,0c-.11,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.09,2.09,0,0,0,1.66-.54,3.67,3.67,0,0,0,1.2-3.11C108.17,88,106.75,86.65,105.77,84.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M95.09,83.06a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64A2.12,2.12,0,0,0,96.46,91a3.7,3.7,0,0,0,1.2-3.11C97.49,86.2,96.07,84.88,95.09,83.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M84.41,81.29a7.57,7.57,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.24h0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.73,3.73,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.2-3.1C86.81,84.43,85.39,83.1,84.41,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M73.73,79.51a7.5,7.5,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55A7.82,7.82,0,0,1,71,79.12c-1.46,1.45-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C76.13,82.65,74.71,81.33,73.73,79.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M63.05,77.74a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.27.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.71,3.71,0,0,0,1.2-3.11C65.45,80.88,64,79.56,63.05,77.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M52.37,76a7.57,7.57,0,0,1-.77-2c0-.18-.08-.37-.11-.57s-.05-.24-.08-.24,0,0,0,0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89A3.71,3.71,0,0,0,46,82.78a2.11,2.11,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.2-3.1C54.77,79.11,53.35,77.78,52.37,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M41.69,74.19a7.5,7.5,0,0,1-.77-2c0-.18-.08-.38-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.28.47-.32.55A8,8,0,0,1,39,73.8c-1.46,1.45-3.2,2.31-3.85,3.88A3.7,3.7,0,0,0,35.36,81a2.05,2.05,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81A3.85,3.85,0,0,0,39.44,80a2.62,2.62,0,0,0,2,2.64,2.13,2.13,0,0,0,1.67-.54A3.7,3.7,0,0,0,44.26,79C44.09,77.33,42.67,76,41.69,74.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M46.74,49.73a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s0,.24.08.25l0,0a0,0,0,0,0,0,0c.1,0,.27-.47.31-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.25-3.32,2.13,2.13,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82A3.71,3.71,0,0,0,49,43.9a2.64,2.64,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.53,3.72,3.72,0,0,0-1.2,3.11C44.33,46.59,45.76,47.92,46.74,49.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M57.41,51.5a7.36,7.36,0,0,1,.77,2c0,.18.08.37.11.57s.05.24.08.24,0,0,0,0,0,0,0,0,.27-.47.32-.55a7.32,7.32,0,0,1,1.4-1.87c1.45-1.46,3.2-2.31,3.84-3.88a3.7,3.7,0,0,0-.25-3.32,2.11,2.11,0,0,0-1.45-1,2.26,2.26,0,0,0-2,.82,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C55,48.37,56.44,49.69,57.41,51.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M68.1,53.28a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s0,.24.08.25l0,0s0,0,0,0,.27-.47.32-.55a7.27,7.27,0,0,1,1.4-1.86c1.45-1.46,3.19-2.32,3.84-3.89a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.62,2.62,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.73,3.73,0,0,0-1.2,3.11C65.7,50.14,67.12,51.46,68.1,53.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M78.78,55.05a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s0,.25.08.25l0,0s0,0,0,0,.27-.47.32-.56a7.45,7.45,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.84-3.89a3.7,3.7,0,0,0-.25-3.32,2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82A3.82,3.82,0,0,0,81,49.22a2.64,2.64,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.53,3.75,3.75,0,0,0-1.2,3.11C76.37,51.91,77.8,53.24,78.78,55.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M89.46,56.82a7.69,7.69,0,0,1,.76,2,4.8,4.8,0,0,1,.11.57c0,.16,0,.24.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.55a7.56,7.56,0,0,1,1.4-1.87c1.45-1.45,3.2-2.31,3.84-3.88A3.7,3.7,0,0,0,95.79,50a2.07,2.07,0,0,0-1.45-1,2.23,2.23,0,0,0-2,.81A3.82,3.82,0,0,0,91.71,51a2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54A3.73,3.73,0,0,0,86.88,52C87.05,53.69,88.48,55,89.46,56.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M100.14,58.6a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s0,.24.08.25l0,0s0,0,0,0,.27-.46.32-.55a7.27,7.27,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.18,2.18,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C97.74,55.46,99.16,56.78,100.14,58.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M110.82,60.37a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s0,.25.08.25,0,0,0,0,0,0,0,0,.27-.47.32-.56a7.45,7.45,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.76,3.76,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.82,3.82,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C108.42,57.23,109.84,58.56,110.82,60.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M121.5,62.14a7.69,7.69,0,0,1,.76,2,4.8,4.8,0,0,1,.11.57c0,.16,0,.24.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.55a7.56,7.56,0,0,1,1.4-1.87c1.45-1.45,3.2-2.31,3.84-3.88a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.2,2.2,0,0,0-1.95.81,3.65,3.65,0,0,0-.68,1.15,2.64,2.64,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C119.1,59,120.52,60.33,121.5,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M132.18,63.92a7.62,7.62,0,0,1,.76,2,5.72,5.72,0,0,1,.11.57c0,.16,0,.24.08.25a0,0,0,0,0,0,0s0,0,0,0,.27-.46.32-.55a7.51,7.51,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.18,2.18,0,0,0-1.95.82,3.49,3.49,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C129.78,60.78,131.2,62.1,132.18,63.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M129.74,66.4a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s-.05-.24-.08-.25,0,0,0,0a0,0,0,0,0,0,0c-.1,0-.27.47-.32.56A7.45,7.45,0,0,1,127,66c-1.45,1.46-3.19,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C132.14,69.54,130.71,68.22,129.74,66.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M119.06,64.63a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.58s-.05-.24-.08-.24h0s0,0,0,0-.27.47-.32.56a7.66,7.66,0,0,1-1.39,1.86c-1.46,1.46-3.21,2.32-3.85,3.88a3.72,3.72,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.53,3.76,3.76,0,0,0,1.2-3.12C121.46,67.77,120,66.44,119.06,64.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M108.37,62.86a7.83,7.83,0,0,1-.76-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a7.5,7.5,0,0,1-1.4,1.87c-1.45,1.45-3.2,2.31-3.84,3.88a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.64,2.64,0,0,0,2,2.64,2.11,2.11,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C110.78,66,109.35,64.67,108.37,62.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M97.69,61.08a7.62,7.62,0,0,1-.76-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0a0,0,0,0,0,0,0c-.1,0-.27.47-.32.56A7.45,7.45,0,0,1,95,60.68c-1.45,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.65,3.65,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63A2.1,2.1,0,0,0,99.07,69a3.74,3.74,0,0,0,1.2-3.11C100.1,64.22,98.67,62.9,97.69,61.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M87,59.31a7.36,7.36,0,0,1-.77-2,4.8,4.8,0,0,1-.11-.57c0-.16,0-.24-.08-.24h0s0,0,0,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.45,1.46-3.2,2.32-3.84,3.88a3.72,3.72,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C89.41,62.44,88,61.12,87,59.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M76.33,57.54a7.83,7.83,0,0,1-.76-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a7.75,7.75,0,0,1-1.4,1.87c-1.45,1.45-3.2,2.31-3.84,3.88A3.7,3.7,0,0,0,70,64.34a2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.65,3.65,0,0,0,.67-1.14A2.64,2.64,0,0,0,76,66a2.12,2.12,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C78.74,60.67,77.31,59.35,76.33,57.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M65.65,55.76a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.17,0-.24-.08-.25l0,0a0,0,0,0,0,0,0c-.1,0-.27.47-.32.56a7.7,7.7,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.65,3.65,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63A2.11,2.11,0,0,0,67,63.7a3.74,3.74,0,0,0,1.2-3.11C68.05,58.9,66.63,57.57,65.65,55.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M55,54a7.69,7.69,0,0,1-.76-2,4.8,4.8,0,0,1-.11-.57c0-.16-.05-.24-.08-.24h0s0,0,0,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.45,1.46-3.2,2.31-3.84,3.88a3.72,3.72,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C57.37,57.12,56,55.8,55,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M44.29,52.22a7.83,7.83,0,0,1-.76-2,5.22,5.22,0,0,1-.11-.57c0-.16-.05-.24-.08-.25l0,0s0,0,0,0S43,49.86,43,50a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88A3.73,3.73,0,0,0,38,59a2.07,2.07,0,0,0,1.45,1,2.18,2.18,0,0,0,2-.82A3.49,3.49,0,0,0,42,58.05a2.64,2.64,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54A3.73,3.73,0,0,0,46.87,57C46.69,55.35,45.27,54,44.29,52.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M37,114.7a7.77,7.77,0,0,1,.77,2c0,.19.08.38.11.58s0,.24.08.24,0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.45,3.2-2.31,3.85-3.88a3.72,3.72,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C34.59,111.56,36,112.89,37,114.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M47.67,116.48a7.5,7.5,0,0,1,.77,2c0,.19.08.37.11.57s.05.24.08.25l0,0s0,0,0,0,.27-.47.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.7,3.7,0,0,0-.26-3.32,2.05,2.05,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14A2.62,2.62,0,0,0,48,108a2.09,2.09,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C45.27,113.34,46.69,114.66,47.67,116.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M58.35,118.25a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s.05.25.08.25,0,0,0,0,0,0,0,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.08,2.08,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C56,115.11,57.37,116.43,58.35,118.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M69,120a7.77,7.77,0,0,1,.77,2c0,.19.08.38.11.58s0,.24.08.24h0l0,0c.11,0,.28-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.72,3.72,0,0,0-.26-3.33,2.11,2.11,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.06,2.06,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C66.63,116.89,68.05,118.21,69,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M79.71,121.8a7.63,7.63,0,0,1,.77,2c0,.19.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.46.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82A3.67,3.67,0,0,0,82,116,2.62,2.62,0,0,0,80,113.32a2.1,2.1,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C77.31,118.66,78.73,120,79.71,121.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M90.39,123.57a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.25.08.25,0,0,0,0l0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.08,2.08,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.79,3.79,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C88,120.43,89.41,121.75,90.39,123.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M101.07,125.34a7.42,7.42,0,0,1,.77,2c0,.19.08.38.11.58s0,.24.08.24h0l0,0c.11,0,.28-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.75,3.75,0,0,0-.25-3.33,2.15,2.15,0,0,0-1.45-1,2.23,2.23,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-1.95-2.64,2.06,2.06,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C98.67,122.21,100.09,123.53,101.07,125.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M111.75,127.12a7.29,7.29,0,0,1,.77,2c0,.19.08.37.11.57s.05.24.08.25l0,0s0,0,0,0,.28-.46.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.6,2.6,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C109.35,124,110.77,125.3,111.75,127.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M122.43,128.89a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.25.08.25,0,0,0,0,0,0,0,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.25-3.32,2.1,2.1,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.69,3.69,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.72,3.72,0,0,0-1.2,3.12C120,125.75,121.45,127.08,122.43,128.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M120,131.38a7.84,7.84,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16-.05-.24-.09-.25l0,0s0,0,0,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.17,2.17,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.64,2.12,2.12,0,0,0,1.67-.54,3.74,3.74,0,0,0,1.2-3.11C122.39,134.51,121,133.19,120,131.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M109.31,129.6a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16,0-.24-.09-.25s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,1.95-.82,3.49,3.49,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C111.71,132.74,110.29,131.41,109.31,129.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M98.63,127.83a7.7,7.7,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57q0-.24-.09-.24h0l0,0c-.1,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.31-3.85,3.88a3.72,3.72,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.67,3.67,0,0,0,1.2-3.11C101,131,99.61,129.64,98.63,127.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M88,126.06a7.84,7.84,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.47-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.17,2.17,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.72,3.72,0,0,0,1.21-3.11C90.35,129.19,88.93,127.87,88,126.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M77.27,124.28a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16-.05-.24-.09-.25s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.7,3.7,0,0,0,1.19-3.11C79.67,127.42,78.25,126.09,77.27,124.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M66.59,122.51a7.7,7.7,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57q0-.24-.09-.24h0l0,0c-.11,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.31-3.85,3.88a3.72,3.72,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C69,125.64,67.57,124.32,66.59,122.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M55.91,120.73a7.63,7.63,0,0,1-.77-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25,0,0,0,0l0,0c-.11,0-.27.48-.32.56a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.18,2.18,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.68,3.68,0,0,0,1.2-3.11C58.31,123.87,56.89,122.55,55.91,120.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M45.23,119a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.17,0-.25-.09-.25s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82A3.79,3.79,0,0,0,43,124.8a2.61,2.61,0,0,0,2,2.63,2.08,2.08,0,0,0,1.66-.53,3.68,3.68,0,0,0,1.2-3.11C47.63,122.1,46.21,120.77,45.23,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M34.55,117.19a7.7,7.7,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16,0-.24-.09-.24h0l0,0c-.11,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.19,2.19,0,0,0,2-.81A3.85,3.85,0,0,0,32.3,123a2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C37,120.32,35.53,119,34.55,117.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M39.6,92.72a7.62,7.62,0,0,1,.76,2,5.4,5.4,0,0,1,.11.58c0,.16.05.23.08.24h0s0,0,0,0,.27-.47.32-.56a7.7,7.7,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.82,3.54,3.54,0,0,0-.68,1.15,2.64,2.64,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.53A3.75,3.75,0,0,0,37,87.89C37.2,89.58,38.62,90.9,39.6,92.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M50.28,94.49a7.69,7.69,0,0,1,.76,2,4.8,4.8,0,0,1,.11.57c0,.16.05.24.08.25l0,0s0,0,0,0,.27-.47.32-.56A7.45,7.45,0,0,1,53,94.89c1.46-1.46,3.2-2.32,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.82,3.85,3.85,0,0,0-.68,1.15,2.64,2.64,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C47.88,91.35,49.3,92.68,50.28,94.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M61,96.27a7.48,7.48,0,0,1,.76,2,5.72,5.72,0,0,1,.11.57c0,.16.05.24.08.25l0,0s0,0,0,0,.27-.48.32-.56a7.7,7.7,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.18,2.18,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.64,2.64,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C58.56,93.13,60,94.45,61,96.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M71.64,98a7.62,7.62,0,0,1,.76,2,5.4,5.4,0,0,1,.11.58c0,.16,0,.23.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89A3.74,3.74,0,0,0,78,91.23a2.13,2.13,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.82,3.54,3.54,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.53,3.75,3.75,0,0,0-1.2,3.11C69.24,94.9,70.66,96.22,71.64,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M82.32,99.81a7.69,7.69,0,0,1,.76,2,4.8,4.8,0,0,1,.11.57c0,.16,0,.24.08.25l0,0s0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88A3.73,3.73,0,0,0,88.65,93a2.07,2.07,0,0,0-1.45-1,2.17,2.17,0,0,0-2,.81A3.85,3.85,0,0,0,84.57,94a2.63,2.63,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54A3.73,3.73,0,0,0,79.74,95C79.92,96.68,81.34,98,82.32,99.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M93,101.59a7.62,7.62,0,0,1,.76,2,5.72,5.72,0,0,1,.11.57c0,.17,0,.24.08.25a0,0,0,0,0,0,0s0,0,0,0,.27-.47.32-.56a7.7,7.7,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.18,2.18,0,0,0-1.95.82,3.67,3.67,0,0,0-.68,1.14,2.64,2.64,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54,3.69,3.69,0,0,0-1.19,3.11C90.6,98.45,92,99.77,93,101.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M103.68,103.36a7.93,7.93,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57c0,.16,0,.24.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.82,3.73,3.73,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C101.28,100.22,102.7,101.54,103.68,103.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M114.36,105.14a7.16,7.16,0,0,1,.76,2,5.22,5.22,0,0,1,.11.57c0,.16,0,.24.08.25a.05.05,0,0,0,0,0s0,0,0,0,.27-.47.32-.55a7.76,7.76,0,0,1,1.4-1.86c1.46-1.47,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.81,3.85,3.85,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.12,2.12,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C112,102,113.38,103.32,114.36,105.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M125,106.91a7.62,7.62,0,0,1,.76,2,5.4,5.4,0,0,1,.11.58c0,.16,0,.23.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.19,2.19,0,0,0-1.95.82,3.67,3.67,0,0,0-.68,1.14,2.64,2.64,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54,3.69,3.69,0,0,0-1.19,3.11C122.64,103.77,124.06,105.09,125,106.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M122.6,109.39a7.17,7.17,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.12,2.12,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.64,2.64,0,0,0,2,2.64,2.13,2.13,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C125,112.53,123.57,111.21,122.6,109.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M111.92,107.62a7.24,7.24,0,0,1-.77-2c0-.18-.08-.37-.11-.57s-.05-.23-.08-.24h0l0,0c-.11,0-.28.47-.33.56a7.66,7.66,0,0,1-1.39,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.15,2.15,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.52,3.52,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.53,3.72,3.72,0,0,0,1.2-3.11C114.32,110.76,112.89,109.44,111.92,107.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M101.24,105.85a7.36,7.36,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.47-.33.55a7.52,7.52,0,0,1-1.39,1.87c-1.46,1.46-3.2,2.32-3.85,3.88a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.81,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C103.64,109,102.21,107.66,101.24,105.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M90.56,104.07a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.27.47-.31.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.21,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.65,2.65,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C93,107.21,91.53,105.89,90.56,104.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M79.88,102.3a7.24,7.24,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.23-.08-.24,0,0,0,0,0,0,0,0-.27.47-.32.56a7.66,7.66,0,0,1-1.39,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.15,2.15,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.72,3.72,0,0,0,1.2-3.1C82.28,105.44,80.85,104.12,79.88,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M69.2,100.53a7.36,7.36,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.48-.33.56a7.47,7.47,0,0,1-1.39,1.86c-1.46,1.46-3.21,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.81,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.11,2.11,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C71.6,103.66,70.17,102.34,69.2,100.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M58.52,98.75a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25,0,0,0,0,0,0,0,0-.27.47-.32.56a7.66,7.66,0,0,1-1.39,1.86c-1.46,1.46-3.21,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.65,2.65,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.74,3.74,0,0,0,1.2-3.11C60.91,101.89,59.49,100.57,58.52,98.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M47.83,97a7.55,7.55,0,0,1-.76-2c0-.18-.08-.37-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.56a7.66,7.66,0,0,1-1.39,1.86c-1.47,1.46-3.21,2.32-3.85,3.88a3.72,3.72,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C50.24,100.12,48.81,98.79,47.83,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M37.16,95.2a7.17,7.17,0,0,1-.77-2,5.72,5.72,0,0,1-.11-.57c0-.16-.05-.24-.08-.25l0,0a0,0,0,0,0,0,0c-.1,0-.27.48-.32.56a7.51,7.51,0,0,1-1.4,1.86c-1.45,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.81A3.82,3.82,0,0,0,34.9,101a2.64,2.64,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C39.56,98.34,38.13,97,37.16,95.2Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M91.44,27.53,71.7,29.1l.52,2.19L69.73,45.05l2.7.72-.38,3.12,2.3,1.48-.18,1.77s2.55,1.07,1.06,2.57-2.79,4.4,4.3,4.8c4.32.24,6.53,2.25,2.91,8.44,0-.58,3,4,7.66,4.3,7.17.41,17.14-3.21,17.14-3.21S91.78,33.28,91.44,27.53Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M72.7,31.61a2.3,2.3,0,0,0,1.24,2.92,12.26,12.26,0,0,0,2.75-.83c1.63-.67,5.17-.23,5.65.34s-1-3.28-6.62-1.61C72.25,33.46,72.7,31.61,72.7,31.61Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.66,35A6.08,6.08,0,0,0,76.93,35c1.61-.56,3.84-.44,4.92.57a9.13,9.13,0,0,0-4.3.27s.56,2-.66,2.21-1.3-2-1.3-2A3.15,3.15,0,0,1,73.66,35Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M89.12,27S82.58,29.85,87,55.93c0,0,.81,4.67-2.27,6.88s12.41,4.2,28.57,1.74c0,0,6.26-6.2-1.49-15.45-2.29-2.72-5.5-18-2.6-22.07Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M71.5,28.56s13-3.63,38.25-1l-.38,1.87S87.61,27.56,72,30.18Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M75.34,38.47s1.63,2.34,4.5.34C79.84,38.81,76.15,39.64,75.34,38.47Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M82.58,67.6,71.49,69.1A22,22,0,0,0,89.87,81.29c17,1.46,28.23-12.59,28.23-12.59l-12-2.1a17.29,17.29,0,0,1-12.75,5.75C84.92,72.6,82.58,67.6,82.58,67.6Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M109.59,28.68,111,20.17S99.47,14,87.6,12.22l-4,4.43-3.4-5.47-2.29,5.4L73,8.85l-1.34,8.94L70,15.21l1.9,15S76,25.86,109.08,28"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "69.99 15.21 71.98 19.64 73.23 10.02 77.98 19.02 80.19 11.18 77.86 16.02 73.03 8.85 71.61 16.14 69.99 15.21"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M86.61,13.27s13.75,3,24,8.87l.42-2S96,12.8,87.6,12.22Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-104",
    points: "87.69 12.89 83.52 18.06 80.19 11.18 83.52 15.39 87.6 12.22"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M74.26,24.93a5,5,0,0,1,.68,1.15c0,.11.09.23.13.34s.06.15.08.15l0,0s0,0,0,0,.12-.32.14-.38a5,5,0,0,1,.66-1.3c.75-1.06,1.73-1.77,2-2.81a2.36,2.36,0,0,0-.52-2,1.33,1.33,0,0,0-1-.46,1.37,1.37,0,0,0-1.12.72,2.35,2.35,0,0,0-.3.78,1.64,1.64,0,0,0-1.49-1.42,1.33,1.33,0,0,0-1,.51,2.31,2.31,0,0,0-.4,2C72.43,23.25,73.46,23.91,74.26,24.93Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M44.94,99l8.73-11.85-3.6-2a15.44,15.44,0,0,1-4-4.26c-.37-.67-2.31.16-.48,3l1.5,2.78-6.66-5s-3.67-3.06-3.76-1.57c-.06.94,1.41,2.8,2,3.17s5.1,5.25,5.1,5.25l-5.4-3.72s-4-3-4.31-2.49c-1.17,2,1.45,3.71,2.17,4.12s6,4.78,6,4.78l-7-3.59s-2.7-1.78-2.86-1c-.39,1.77,1.51,2.93,1.9,3.13.7.37,6,3.57,6,3.57l-1.82-.17s-5.37-1.7-5.39-1.24c-.09,2.3,9.57,5.89,9.57,5.89A22.71,22.71,0,0,0,44.94,99Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "98.79 110.02 95.9 110.16 95.06 112.67 95.06 112.67 95.06 112.67 95.06 112.67 95.06 112.67 97.95 112.53 98.79 110.02 98.79 110.02 98.79 110.02 98.79 110.02 98.79 110.02"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.33,71.35s3.17,1.26,3.83,6.88v25.71l-39.08,4.41Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "90.58 109.1 94.08 108.35 129.33 71.35 126.58 70.85 90.58 109.1"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.58 109.1 75.33 101.35 111.67 67.95 126.83 70.85 90.58 109.1"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "115.58 68.35 123.2 70.1 87.33 106.6 80.08 103.41 115.58 68.35"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "53.68 86.68 94.58 108.6 52.81 113.26 33.06 115.97 53.68 86.68"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "33.06 115.97 53.68 86.68 59.83 90.1 41.33 114.6 33.06 115.97"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M88.33,65.18s3.83-1,4-6.5-4.75-17.16-1.92-26.33c0,0,.58,17.83,2.92,26.17S88.33,65.18,88.33,65.18Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M95.33,65.18s3.83-1,4-6.5S95,41.52,97.83,32.35c0,0,.16,17.83,2.5,26.17S95.33,65.18,95.33,65.18Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M102.33,65.18s3.83-1,4-6.5-4.92-17.16-2.09-26.33c0,0,.75,17.83,3.09,26.17S102.33,65.18,102.33,65.18Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M109.37,29.43S109,42.52,112,47.52s6.32,13.57,1.33,17a12.12,12.12,0,0,0-1-12.45c-3.47-5.18-6.59-15-4.42-22.83Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M85.26,102a4.66,4.66,0,0,1-.38,1.26c0,.1-.1.21-.16.31s-.06.14,0,.15,0,0,0,0,0,0,0,0,.3-.12.36-.15a4.74,4.74,0,0,1,1.37-.38c1.25-.16,2.42.07,3.32-.45a2.27,2.27,0,0,0,1.12-1.7,1.31,1.31,0,0,0-.33-1,1.37,1.37,0,0,0-1.26-.34,2.1,2.1,0,0,0-.75.31,1.62,1.62,0,0,0,0-2,1.26,1.26,0,0,0-1-.37,2.28,2.28,0,0,0-1.74,1.06C85.26,99.56,85.46,100.73,85.26,102Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M90.08,97.22a4.3,4.3,0,0,1-.37,1.26c0,.1-.1.21-.16.31s-.07.14,0,.15,0,0,0,0v0s.31-.13.37-.15a4.65,4.65,0,0,1,1.37-.38c1.25-.16,2.42.07,3.32-.45a2.23,2.23,0,0,0,1.11-1.7,1.24,1.24,0,0,0-.33-1,1.35,1.35,0,0,0-1.25-.34,2.22,2.22,0,0,0-.76.31,1.61,1.61,0,0,0,0-2,1.28,1.28,0,0,0-1-.37,2.28,2.28,0,0,0-1.74,1.06C90.09,94.81,90.28,96,90.08,97.22Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M94.91,92.47a5.14,5.14,0,0,1-.37,1.26l-.17.31c-.05.09-.06.14-.05.15h0s0,0,0,0,.31-.13.36-.15a4.72,4.72,0,0,1,1.38-.38c1.25-.16,2.41.07,3.31-.45a2.27,2.27,0,0,0,1.12-1.7,1.27,1.27,0,0,0-.33-1,1.35,1.35,0,0,0-1.25-.34,2.07,2.07,0,0,0-.76.31,1.59,1.59,0,0,0,0-2,1.24,1.24,0,0,0-1-.37,2.31,2.31,0,0,0-1.75,1.06C94.92,90.06,95.11,91.23,94.91,92.47Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M99.74,87.72A4.88,4.88,0,0,1,99.36,89c0,.1-.1.21-.16.31s-.06.14,0,.15,0,0,0,0v0s.31-.13.36-.15a4.74,4.74,0,0,1,1.37-.38c1.26-.16,2.42.07,3.32-.45a2.28,2.28,0,0,0,1.12-1.7,1.31,1.31,0,0,0-.33-1,1.37,1.37,0,0,0-1.26-.34,2.27,2.27,0,0,0-.75.3,1.59,1.59,0,0,0,0-2,1.26,1.26,0,0,0-1-.37,2.29,2.29,0,0,0-1.74,1.06C99.74,85.31,99.94,86.48,99.74,87.72Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M104.56,83a4.49,4.49,0,0,1-.37,1.26c0,.1-.1.21-.16.31s-.07.14,0,.15,0,0,0,0v0s.31-.13.37-.15a4.65,4.65,0,0,1,1.37-.38c1.25-.16,2.42.07,3.32-.45a2.23,2.23,0,0,0,1.11-1.7,1.24,1.24,0,0,0-.33-1,1.35,1.35,0,0,0-1.25-.34,2.41,2.41,0,0,0-.76.3,1.59,1.59,0,0,0,0-2,1.28,1.28,0,0,0-1-.37,2.28,2.28,0,0,0-1.74,1.06C104.57,80.56,104.77,81.73,104.56,83Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M109.39,78.22a5.27,5.27,0,0,1-.37,1.26l-.17.31c0,.09-.06.14,0,.15h0s0,0,0,0,.31-.13.36-.15a4.8,4.8,0,0,1,1.38-.38c1.25-.16,2.41.07,3.32-.45a2.25,2.25,0,0,0,1.11-1.7,1.27,1.27,0,0,0-.33-1,1.35,1.35,0,0,0-1.25-.34,2.32,2.32,0,0,0-.76.3,1.61,1.61,0,0,0,0-2,1.3,1.3,0,0,0-1-.36,2.31,2.31,0,0,0-1.75,1.06C109.4,75.8,109.59,77,109.39,78.22Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M114.22,73.47a4.7,4.7,0,0,1-.38,1.25,3.18,3.18,0,0,1-.16.32c-.05.09-.06.14-.05.15s0,0,0,0,0,0,0,0,.31-.13.36-.15a4.72,4.72,0,0,1,1.38-.38c1.25-.16,2.41.07,3.31-.45a2.28,2.28,0,0,0,1.12-1.7,1.31,1.31,0,0,0-.33-1,1.36,1.36,0,0,0-1.26-.34,2.27,2.27,0,0,0-.75.3,1.61,1.61,0,0,0,0-2,1.28,1.28,0,0,0-1-.36,2.27,2.27,0,0,0-1.74,1.06C114.22,71.05,114.42,72.23,114.22,73.47Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M38,114.06a3.55,3.55,0,0,1-.1.9c0,.07,0,.15-.08.23s0,.1,0,.11h0a0,0,0,0,0,0,0s.19-.12.22-.14a3.46,3.46,0,0,1,.87-.41c.81-.25,1.6-.21,2.14-.67a1.57,1.57,0,0,0,.55-1.28.93.93,0,0,0-.34-.66.85.85,0,0,0-.86-.09,1.36,1.36,0,0,0-.47.29,1.16,1.16,0,0,0-.2-1.38.89.89,0,0,0-.71-.14,1.51,1.51,0,0,0-1,.92A6.61,6.61,0,0,0,38,114.06Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M40.66,110.29a3.57,3.57,0,0,1-.11.9c0,.07,0,.15-.07.23s0,.1,0,.11h0s.19-.12.23-.14a3.09,3.09,0,0,1,.86-.41c.81-.25,1.61-.21,2.14-.67a1.57,1.57,0,0,0,.55-1.28.89.89,0,0,0-.33-.66.87.87,0,0,0-.87-.09,1.54,1.54,0,0,0-.47.28,1.12,1.12,0,0,0-.2-1.37.88.88,0,0,0-.71-.14,1.53,1.53,0,0,0-1,.92A6.63,6.63,0,0,0,40.66,110.29Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M43.31,106.52a3.55,3.55,0,0,1-.1.9c0,.07-.05.15-.08.23s0,.1,0,.11h0s.19-.12.22-.14a3.46,3.46,0,0,1,.87-.41c.8-.24,1.6-.21,2.14-.67a1.56,1.56,0,0,0,.54-1.28.89.89,0,0,0-.33-.66.87.87,0,0,0-.87-.09,1.42,1.42,0,0,0-.46.29,1.14,1.14,0,0,0-.21-1.38.86.86,0,0,0-.7-.14,1.52,1.52,0,0,0-1,.92A6.63,6.63,0,0,0,43.31,106.52Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M46,102.75a3.57,3.57,0,0,1-.11.9c0,.07,0,.15-.07.23s0,.1,0,.11h0s.19-.12.22-.14a3.15,3.15,0,0,1,.87-.41c.81-.25,1.61-.21,2.14-.67a1.57,1.57,0,0,0,.55-1.28.92.92,0,0,0-.33-.66.87.87,0,0,0-.87-.09,1.54,1.54,0,0,0-.47.28,1.14,1.14,0,0,0-.2-1.37.88.88,0,0,0-.71-.14,1.5,1.5,0,0,0-1,.92A6.63,6.63,0,0,0,46,102.75Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M48.62,99a3.06,3.06,0,0,1-.11.89,2.17,2.17,0,0,1-.07.24.35.35,0,0,0,0,.1h0a0,0,0,0,0,0,0s.19-.12.22-.14a3.15,3.15,0,0,1,.87-.41c.8-.25,1.6-.22,2.14-.67a1.56,1.56,0,0,0,.54-1.28.87.87,0,0,0-.33-.66A.89.89,0,0,0,51,97a1.3,1.3,0,0,0-.46.3,1.14,1.14,0,0,0-.21-1.38.88.88,0,0,0-.71-.14,1.52,1.52,0,0,0-1,.92A6.63,6.63,0,0,0,48.62,99Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M51.27,95.21a3.19,3.19,0,0,1-.1.9c0,.07-.05.15-.07.23s0,.1,0,.1,0,0,0,0v0s.19-.12.22-.14a3.29,3.29,0,0,1,.87-.41c.81-.25,1.6-.22,2.14-.67A1.57,1.57,0,0,0,54.88,94a1,1,0,0,0-.34-.67.9.9,0,0,0-.86-.09,1.5,1.5,0,0,0-.47.3,1.16,1.16,0,0,0-.2-1.38A.88.88,0,0,0,52.3,92a1.5,1.5,0,0,0-1,.92A6.86,6.86,0,0,0,51.27,95.21Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M53.93,91.44a3.17,3.17,0,0,1-.11.9c0,.07,0,.15-.07.23s0,.1,0,.11h0s.2-.12.23-.14a3.23,3.23,0,0,1,.86-.41c.81-.25,1.61-.21,2.15-.67a1.59,1.59,0,0,0,.54-1.28.89.89,0,0,0-.33-.66.87.87,0,0,0-.87-.09,1.54,1.54,0,0,0-.47.28,1.12,1.12,0,0,0-.2-1.37.88.88,0,0,0-.71-.14,1.52,1.52,0,0,0-1,.92A6.63,6.63,0,0,0,53.93,91.44Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M75.7,53.47l-2,2.13.13,3S80.2,60,80.7,60c0,0,.5-2.62.13-3.37S78,54.1,75.7,53.47Z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "72.33 48.47 77.08 48.85 76.33 47.6 72.43 45.77 72.33 48.47"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "124 171.8 130.66 171.8 132.16 165.13 124.83 160.8 124 171.8"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "116.42 170.92 109.98 168.87 110.58 161.97 119 160.04 116.42 170.92"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M126.44,168.87s3.35-4.37-2.54-8.85l.37-3-4.93-.6-.54,4.4Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M125.45,163.33a6.07,6.07,0,1,0,1.17,4.89A6.08,6.08,0,0,0,125.45,163.33Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M126.42,168.66s2.65-4.57-2.52-8.64l0-.88S130.31,163.67,126.42,168.66Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M121.31,159.91s-1.25,3.38-4.41,3.61-1.76,5.82-1.76,5.82S109.89,160.47,121.31,159.91Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M121.31,159.91s-4.19-.68-6.55,2.46c0,0,6.81-5,11.47,1.48,0,0-1.45-2.94-3.89-3.87l.16-2.53-.77-.09Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M119.63,161.26s-.31,1.68-3.69,1.68A3.72,3.72,0,0,1,119.63,161.26Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M122.68,172.78a1.91,1.91,0,0,0,2.59-1.56,6.45,6.45,0,0,0-3.8-3S124.5,170.71,122.68,172.78Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M125.27,171.22s0-2.44-3.59-2.94c0,0,4.37,2.52,2.8,4.3C124.48,172.58,125.22,172.41,125.27,171.22Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 99.53,
    y: 129.13,
    width: 50.91,
    height: 4.7,
    transform: "translate(-20.85 239.37) rotate(-82.95)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "115.9 170.79 111.25 167.46 109.98 168.87 115.9 170.79"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "116.66 160.63 112.08 163.13 110.58 161.97 116.66 160.63"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "130.66 171.8 129.91 170.05 125.27 171.22 125.25 171.71 130.66 171.8"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "132.16 165.13 130.58 166.05 126.75 161.96 132.16 165.13"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "111.25 167.46 112.08 163.13 110.58 161.97 109.98 168.87 111.25 167.46"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "130.66 171.8 132.16 165.13 130.58 166.05 129.91 170.05 130.66 171.8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M67.31,153.73l-28.37-5.36s-5.61-.54-5.61-7.23V115.42l99.6-11.52s-25.12,37.5-33,44.2c-.87.75-4.91,1.64-9.87,2.48C80.44,152.23,67.31,153.73,67.31,153.73Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M122.36,147.77a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.58s0-.23-.08-.24,0,0,0,0l0,0c-.11,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.05,2.05,0,0,0,1.66-.54,3.69,3.69,0,0,0,1.2-3.1C124.76,150.91,123.34,149.59,122.36,147.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M111.68,146a7.7,7.7,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0,0,0c-.11,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C114.08,149.14,112.66,147.81,111.68,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M101,144.22a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.28.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.26,3.32,2.05,2.05,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.64,2.64,0,0,0,2,2.64,2.13,2.13,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C103.4,147.36,102,146,101,144.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M90.32,142.45a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.58s0-.23-.08-.24h0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.11,2.11,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.73,3.73,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.2-3.1C92.72,145.59,91.3,144.27,90.32,142.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M79.64,140.68a7.7,7.7,0,0,1-.77-2c0-.18-.08-.37-.11-.57s-.05-.24-.08-.25l0,0,0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C82,143.82,80.62,142.49,79.64,140.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M69,138.9a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.73,3.73,0,0,0,.25,3.32,2.12,2.12,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.64,2.64,0,0,0,2,2.64,2.13,2.13,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C71.36,142,69.94,140.72,69,138.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M58.28,137.13a7.24,7.24,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.23-.08-.24h0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.11,2.11,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82A3.73,3.73,0,0,0,56,143,2.62,2.62,0,0,0,58,145.6a2.06,2.06,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.2-3.1C60.68,140.27,59.26,138.94,58.28,137.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M47.6,135.36a7.36,7.36,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.45-3.2,2.32-3.85,3.88a3.73,3.73,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,1.95,2.64,2.13,2.13,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C50,138.49,48.58,137.17,47.6,135.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M36.92,133.58a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0,0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.65,2.65,0,0,0,2,2.64,2.13,2.13,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C39.32,136.72,37.9,135.4,36.92,133.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M39.36,131.1a7.63,7.63,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.17.05.24.09.25l0,0s0,0,0,0,.27-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54,3.74,3.74,0,0,0-1.2,3.11C37,128,38.38,129.28,39.36,131.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M50,132.87a7.57,7.57,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57q0,.24.09.24s0,0,0,0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C47.64,129.73,49.06,131.06,50,132.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M60.72,134.65a7.5,7.5,0,0,1,.77,2,5.21,5.21,0,0,1,.1.57c0,.16,0,.24.09.25l0,0,0,0c.11,0,.27-.47.32-.55a7.57,7.57,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.67,3.67,0,0,0-1.2,3.11C58.32,131.51,59.74,132.83,60.72,134.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M71.4,136.42a7.63,7.63,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.17,0,.24.09.25l0,0,0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.68,3.68,0,0,0-1.2,3.11C69,133.28,70.42,134.6,71.4,136.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M82.08,138.19a7.57,7.57,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57q0,.24.09.24s0,0,0,0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.66,3.66,0,0,0-1.2,3.1C79.68,135.05,81.1,136.38,82.08,138.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M92.76,140a7.5,7.5,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16.05.24.09.25l0,0s0,0,0,0,.27-.47.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.44-1,2.22,2.22,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C90.36,136.83,91.78,138.15,92.76,140Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M103.44,141.74a7.63,7.63,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.17,0,.24.09.25l0,0s0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.19,2.19,0,0,0-1.95.82,3.67,3.67,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.08,2.08,0,0,0-1.66.53,3.68,3.68,0,0,0-1.2,3.11C101,138.6,102.46,139.92,103.44,141.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M114.12,143.51a7.7,7.7,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57q0,.24.09.24s0,0,0,0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.72,3.72,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.67,3.67,0,0,0-1.2,3.11C111.72,140.37,113.14,141.7,114.12,143.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M124.8,145.29a7.5,7.5,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16.06.24.09.25l0,0,0,0c.11,0,.27-.48.32-.56a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C122.4,142.15,123.82,143.47,124.8,145.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M119.75,169.75a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.16,0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.56a7.27,7.27,0,0,1-1.4,1.86c-1.45,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.45,1,2.18,2.18,0,0,0,1.95-.82,3.49,3.49,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C122.16,172.89,120.73,171.57,119.75,169.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M109.07,168a7.69,7.69,0,0,1-.76-2c0-.18-.08-.37-.11-.57s0-.24-.08-.24a0,0,0,0,0,0,0s0,0,0,0-.27.47-.32.56a7.7,7.7,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.84,3.88a3.7,3.7,0,0,0,.25,3.32,2.11,2.11,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C111.47,171.11,110.05,169.79,109.07,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M98.39,166.21a7.69,7.69,0,0,1-.76-2,5.22,5.22,0,0,1-.11-.57c0-.16,0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a7.75,7.75,0,0,1-1.4,1.87c-1.45,1.45-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.18,2.18,0,0,0,1.95-.82,3.49,3.49,0,0,0,.68-1.14,2.64,2.64,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54A3.73,3.73,0,0,0,101,171C100.79,169.34,99.37,168,98.39,166.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M87.71,164.43a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.17,0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.56A8,8,0,0,1,85,164c-1.45,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.45,1,2.18,2.18,0,0,0,2-.82,3.49,3.49,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.75,3.75,0,0,0,1.2-3.11C90.11,167.57,88.69,166.24,87.71,164.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M77,162.66a7.69,7.69,0,0,1-.76-2,4.8,4.8,0,0,1-.11-.57c0-.16,0-.24-.08-.24s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.45-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.11,2.11,0,0,0,1.45,1,2.22,2.22,0,0,0,1.95-.82,3.65,3.65,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C79.43,165.79,78,164.47,77,162.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M66.35,160.88a7.62,7.62,0,0,1-.76-2,5.22,5.22,0,0,1-.11-.57c0-.16,0-.24-.08-.25a.05.05,0,0,0,0,0s0,0,0,0-.27.46-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.74,3.74,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.82,3.49,3.49,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C68.75,164,67.33,162.7,66.35,160.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M55.67,159.11a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.17,0-.25-.08-.25l0,0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.82,3.44,3.44,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.11,2.11,0,0,0,1.67-.53,3.75,3.75,0,0,0,1.2-3.11C58.07,162.25,56.65,160.92,55.67,159.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M45,157.34a7.35,7.35,0,0,1-.76-2,4.8,4.8,0,0,1-.11-.57q0-.24-.09-.24s0,0,0,0,0,0,0,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.18,2.18,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C47.39,160.47,46,159.15,45,157.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M34.31,155.56a8,8,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.46-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,1.95-.82,3.67,3.67,0,0,0,.68-1.14A2.61,2.61,0,0,0,34,164a2.11,2.11,0,0,0,1.67-.53,3.73,3.73,0,0,0,1.2-3.11C36.71,158.7,35.29,157.38,34.31,155.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M36.75,153.08a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25,0,0,0,0,0,0,0,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.25-3.32,2.09,2.09,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C34.35,149.94,35.78,151.27,36.75,153.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M47.43,154.85a7.36,7.36,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.24h0l0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.31,3.85-3.88a3.75,3.75,0,0,0-.25-3.33,2.15,2.15,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C45,151.72,46.46,153,47.43,154.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M58.11,156.62a7.49,7.49,0,0,1,.77,2c0,.19.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.46.32-.55a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.64,2.64,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.74,3.74,0,0,0-1.2,3.11C55.71,153.49,57.14,154.81,58.11,156.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M68.79,158.4a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25,0,0,0,0,0,0,0,0,.27-.47.31-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.21-2.32,3.85-3.89a3.7,3.7,0,0,0-.25-3.32,2.1,2.1,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C66.39,155.26,67.82,156.59,68.79,158.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M79.47,160.17a7.36,7.36,0,0,1,.77,2c0,.18.08.37.11.57s.05.24.08.24h0s0,0,0,0,.27-.47.32-.55a7.32,7.32,0,0,1,1.4-1.87c1.45-1.46,3.19-2.31,3.84-3.88a3.75,3.75,0,0,0-.25-3.33,2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C77.07,157,78.5,158.36,79.47,160.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M90.15,161.94a7.49,7.49,0,0,1,.77,2c0,.19.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.47.33-.56a7.27,7.27,0,0,1,1.4-1.86c1.45-1.46,3.19-2.32,3.84-3.89a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.64,2.64,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C87.75,158.81,89.18,160.13,90.15,161.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M100.83,163.72a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s.05.25.08.25,0,0,0,0,0,0,0,0,.27-.47.32-.56a7.66,7.66,0,0,1,1.39-1.86c1.46-1.46,3.21-2.32,3.85-3.89a3.7,3.7,0,0,0-.25-3.32,2.1,2.1,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.75,3.75,0,0,0-1.2,3.11C98.43,160.58,99.86,161.91,100.83,163.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M111.52,165.49a7.69,7.69,0,0,1,.76,2c0,.19.08.37.11.57s0,.24.08.24,0,0,0,0,0,0,0,0,.27-.47.32-.55a7.32,7.32,0,0,1,1.4-1.87c1.45-1.45,3.2-2.31,3.84-3.88a3.7,3.7,0,0,0-.25-3.32,2.11,2.11,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C109.11,162.36,110.54,163.68,111.52,165.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M122.2,167.27a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s.05.24.08.25l0,0a0,0,0,0,0,0,0c.1,0,.27-.47.32-.56a7.51,7.51,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.84-3.89a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.65,3.65,0,0,0-.67,1.14,2.62,2.62,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C119.79,164.13,121.22,165.45,122.2,167.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M129.5,104.78a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.58s-.05-.24-.08-.24,0,0,0,0,0,0,0,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.82,3.58,3.58,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63,2.09,2.09,0,0,0,1.67-.53,3.72,3.72,0,0,0,1.2-3.11C131.9,107.92,130.48,106.59,129.5,104.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M118.82,103a7.36,7.36,0,0,1-.77-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.31-3.85,3.88a3.72,3.72,0,0,0,.26,3.33,2.11,2.11,0,0,0,1.44,1,2.21,2.21,0,0,0,2-.83,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C121.22,106.14,119.8,104.82,118.82,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M108.14,101.23a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s-.05-.24-.08-.25,0,0,0,0l0,0c-.11,0-.28.47-.32.56a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.09,2.09,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.6,2.6,0,0,0,2,2.63,2.09,2.09,0,0,0,1.67-.53,3.71,3.71,0,0,0,1.2-3.11C110.54,104.37,109.12,103.05,108.14,101.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M97.46,99.46a7.42,7.42,0,0,1-.77-2c0-.19-.08-.38-.11-.58s0-.24-.08-.24,0,0,0,0,0,0,0,0-.28.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.31-3.85,3.88a3.75,3.75,0,0,0,.25,3.33,2.1,2.1,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.58,3.58,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.72,3.72,0,0,0,1.2-3.11C99.86,102.6,98.44,101.27,97.46,99.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M86.78,97.69a7.36,7.36,0,0,1-.77-2c0-.19-.08-.37-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.28.47-.32.55A8,8,0,0,1,84,97.29c-1.46,1.45-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.64,2.64,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C89.18,100.82,87.76,99.5,86.78,97.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M76.1,95.91a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25,0,0,0,0,0,0,0,0-.27.47-.31.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.62,2.62,0,0,0,2,2.63,2.09,2.09,0,0,0,1.67-.53,3.71,3.71,0,0,0,1.2-3.11C78.5,99.05,77.07,97.73,76.1,95.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M65.42,94.14a7.42,7.42,0,0,1-.77-2c0-.19-.08-.38-.11-.58s-.05-.24-.08-.24,0,0,0,0,0,0,0,0-.28.47-.33.55a7.52,7.52,0,0,1-1.39,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.75,3.75,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54A3.7,3.7,0,0,0,68,99C67.82,97.28,66.4,96,65.42,94.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M54.74,92.36a7.17,7.17,0,0,1-.77-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.47-.32.55A8,8,0,0,1,52,92c-1.46,1.45-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.64,2.64,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.74,3.74,0,0,0,1.2-3.11C57.14,95.5,55.71,94.18,54.74,92.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M44.06,90.59a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.25-.08-.25,0,0,0,0,0,0,0,0-.27.47-.31.56a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.58,3.58,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C46.46,93.73,45,92.4,44.06,90.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M46.5,88.1a8.23,8.23,0,0,1,.77,2c0,.19.07.37.1.57s.05.24.08.25l0,0s0,0,0,0,.27-.47.32-.55a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.82,3.65,3.65,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54,3.74,3.74,0,0,0-1.2,3.11C44.1,85,45.52,86.29,46.5,88.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M57.18,89.88a8,8,0,0,1,.77,2c0,.19.07.38.1.57s.05.25.08.25l0,0s0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82A3.6,3.6,0,0,0,59.43,84a2.62,2.62,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C54.78,86.74,56.2,88.07,57.18,89.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M67.86,91.65a7.7,7.7,0,0,1,.77,2c0,.18.07.37.1.57s0,.24.09.24h0s0,0,0,0,.27-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.45-1,2.22,2.22,0,0,0-1.95.82,3.65,3.65,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C65.46,88.52,66.88,89.84,67.86,91.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M78.54,93.43a8,8,0,0,1,.77,2,5.21,5.21,0,0,1,.1.57c0,.16,0,.24.08.25l0,0s0,0,0,0,.27-.46.32-.55a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54A3.74,3.74,0,0,0,76,88.6C76.14,90.29,77.56,91.61,78.54,93.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M89.22,95.2a8,8,0,0,1,.77,2,5.4,5.4,0,0,1,.1.58c0,.16,0,.24.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.56A8,8,0,0,1,92,95.6c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.45-1,2.19,2.19,0,0,0-1.95.82,3.6,3.6,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C86.82,92.06,88.24,93.39,89.22,95.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M99.9,97a7.7,7.7,0,0,1,.77,2,5.21,5.21,0,0,1,.1.57q0,.24.09.24h0l0,0c.1,0,.27-.47.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C97.5,93.84,98.92,95.16,99.9,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M110.58,98.75a7.63,7.63,0,0,1,.77,2,5.21,5.21,0,0,1,.1.57c0,.16,0,.24.09.25s0,0,0,0l0,0c.1,0,.27-.47.32-.56a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.19,2.19,0,0,0-1.95.82,3.49,3.49,0,0,0-.68,1.14,2.6,2.6,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C108.18,95.61,109.6,96.93,110.58,98.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M121.26,100.52a7.77,7.77,0,0,1,.77,2,5.4,5.4,0,0,1,.1.58q0,.24.09.24h0l0,0c.1,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.92,3.92,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.63,2.08,2.08,0,0,0-1.66.53,3.68,3.68,0,0,0-1.2,3.11C118.86,97.38,120.28,98.71,121.26,100.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M131.94,102.29a7.7,7.7,0,0,1,.77,2,5.21,5.21,0,0,1,.1.57c0,.16.05.24.09.25l0,0s0,0,0,0,.27-.47.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.18,2.18,0,0,0-1.95.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.71,3.71,0,0,0-1.21,3.11C129.54,99.16,131,100.48,131.94,102.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M126.89,126.76a7.62,7.62,0,0,1-.76-2,5.4,5.4,0,0,1-.11-.58c0-.16,0-.23-.08-.24a0,0,0,0,0,0,0s0,0,0,0-.27.47-.32.56a7.7,7.7,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.45,1,2.18,2.18,0,0,0,1.95-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C129.29,129.9,127.87,128.58,126.89,126.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M116.21,125a7.69,7.69,0,0,1-.76-2,3.38,3.38,0,0,1-.11-.57c0-.16,0-.24-.08-.25a.05.05,0,0,0,0,0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.31,2.12,2.12,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.68,3.68,0,0,0,1.19-3.1C118.61,128.13,117.19,126.8,116.21,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M105.53,123.21a7.5,7.5,0,0,1-.77-2c0-.19-.07-.38-.1-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89A3.73,3.73,0,0,0,99.2,130a2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,1.95-.82,3.67,3.67,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C107.93,126.35,106.51,125,105.53,123.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M94.85,121.44a7.63,7.63,0,0,1-.77-2c0-.19-.07-.38-.1-.58s0-.23-.08-.24,0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.7,3.7,0,0,0,1.19-3.11C97.25,124.58,95.83,123.26,94.85,121.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M84.17,119.67a7.35,7.35,0,0,1-.76-2,3.38,3.38,0,0,1-.11-.57c0-.16,0-.24-.09-.25l0,0,0,0c-.1,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.12,2.12,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.19-3.11C86.57,122.81,85.15,121.48,84.17,119.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M73.49,117.89a7.5,7.5,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16-.05-.24-.09-.25l0,0s0,0,0,0-.27.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.64,2.64,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.19-3.11C75.89,121,74.47,119.71,73.49,117.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M62.81,116.12a7.63,7.63,0,0,1-.77-2,5.4,5.4,0,0,1-.1-.58c0-.16,0-.23-.08-.24h0l0,0c-.11,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.73,3.73,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.11,2.11,0,0,0,1.67-.53A3.71,3.71,0,0,0,65.38,121C65.21,119.26,63.79,117.94,62.81,116.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M52.13,114.35a7.7,7.7,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0,0,0c-.1,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.32-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.12,2.12,0,0,0,1.44,1,2.25,2.25,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.12,2.12,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.19-3.11C54.53,117.48,53.11,116.16,52.13,114.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M41.45,112.57a7.5,7.5,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54A3.67,3.67,0,0,0,44,117.4C43.85,115.71,42.43,114.39,41.45,112.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M43.89,110.09a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25,0,0,0,0,0,0,0,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.08,2.08,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.64,2.64,0,0,0-2-2.64,2.13,2.13,0,0,0-1.67.54,3.71,3.71,0,0,0-1.2,3.11C41.49,107,42.91,108.27,43.89,110.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M54.57,111.86a7.57,7.57,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.24,0,0,0,0l0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.25-3.31,2.09,2.09,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.81,3.73,3.73,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.06,2.06,0,0,0-1.67.54A3.7,3.7,0,0,0,52,107C52.17,108.72,53.59,110.05,54.57,111.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M65.25,113.64a7.17,7.17,0,0,1,.77,2c0,.19.08.37.11.57s.05.24.08.25l0,0,0,0c.11,0,.28-.48.32-.56A7.57,7.57,0,0,1,68,114c1.46-1.47,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.25-3.32,2.09,2.09,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C62.85,110.5,64.27,111.82,65.25,113.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M75.93,115.41a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.58s0,.23.08.24,0,0,0,0,0,0,0,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.25-3.32,2.15,2.15,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C73.53,112.27,75,113.59,75.93,115.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M86.61,117.18a7.57,7.57,0,0,1,.77,2c0,.18.08.37.11.57s.05.23.08.24,0,0,0,0l0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.25-3.31,2.09,2.09,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.81,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.06,2.06,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C84.21,114,85.64,115.37,86.61,117.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M97.29,119a7.17,7.17,0,0,1,.77,2c0,.19.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.48.32-.56a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.25-3.32,2.09,2.09,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C94.89,115.82,96.32,117.14,97.29,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M108,120.73a7.24,7.24,0,0,1,.77,2c0,.18.08.37.11.57s.05.23.08.24,0,0,0,0,0,0,0,0,.28-.47.33-.56a7.66,7.66,0,0,1,1.39-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.25-3.32,2.15,2.15,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.52,3.52,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.68,3.68,0,0,0-1.2,3.1C105.57,117.59,107,118.91,108,120.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M118.65,122.5a7.24,7.24,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.25l0,0,0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.73,3.73,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.81,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C116.25,119.36,117.68,120.69,118.65,122.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M129.33,124.28a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25l0,0s0,0,0,0,.27-.48.31-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.25-3.32,2.1,2.1,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.65,2.65,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C126.93,121.14,128.36,122.46,129.33,124.28Z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M75.05,192l19.74-1.57-.52-2.19,2.49-13.76-2.7-.72.38-3.12-2.3-1.48.18-1.77s-2.55-1.07-1.06-2.57,2.79-4.4-4.3-4.8c-4.33-.24-6.53-2.25-2.91-8.44,0,.58-3-4-7.66-4.3-7.17-.41-17.14,3.21-17.14,3.21S74.71,186.2,75.05,192Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M93.78,187.87A2.29,2.29,0,0,0,92.55,185a12.4,12.4,0,0,0-2.76.83c-1.62.67-5.16.23-5.64-.34s1,3.28,6.62,1.61C94.24,186,93.78,187.87,93.78,187.87Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.83,184.46a6.09,6.09,0,0,0-3.27.07c-1.61.56-3.84.44-4.92-.57a9.13,9.13,0,0,0,4.3-.27s-.56-2,.66-2.21,1.3,2,1.3,2A3.15,3.15,0,0,1,92.83,184.46Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M77.37,192.49s6.54-2.86,2.1-28.93c0,0-.81-4.68,2.27-6.89s-12.42-4.2-28.57-1.74c0,0-6.26,6.2,1.49,15.45,2.28,2.72,5.5,18,2.6,22.07Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M94.79,190.38s-26.3,2.92-37.68.54l-3.62,11s5.75-1.37,8,3.25c0,0,7.5-5.37,13.12,1.13,0,0,6.75-6.13,11.88-.13,0,0,6.37-7.75,12.37-1.87Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M95,190.92s-13,3.63-38.25,1l.37-1.87s21.77,1.87,37.37-.75Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M86.49,206.17s6.37-8.12,12.37-1.87l-4.37-15,2.62,12.5S91,198.92,86.49,206.17Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M74.61,206.3a10.55,10.55,0,0,0-13.12-1.13s-2.25-4.37-8-3.25c0,0,5.12-2.5,8.12,2.13C61.61,204.05,69.36,199.05,74.61,206.3Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M91.15,181s-1.63-2.34-4.5-.34C86.65,180.67,90.33,179.84,91.15,181Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M83.91,151.88,95,150.38a22,22,0,0,0-18.37-12.19c-17-1.46-28.23,12.59-28.23,12.59l12,2.1a17.29,17.29,0,0,1,12.75-5.75C81.57,146.88,83.91,151.88,83.91,151.88Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M121.54,120.45l-8.73,11.85,3.61,2a15.44,15.44,0,0,1,4,4.26c.37.67,2.31-.16.48-3l-1.5-2.78,6.66,5.05s3.66,3.06,3.76,1.57c.06-.94-1.41-2.8-2-3.17s-5.1-5.25-5.1-5.25l5.4,3.72s4,3,4.31,2.49c1.17-2-1.45-3.71-2.17-4.12s-6-4.78-6-4.78l7,3.59s2.7,1.78,2.86,1.05c.39-1.77-1.51-2.93-1.9-3.13-.71-.37-6-3.57-6-3.57l1.82.17s5.37,1.7,5.39,1.24c.09-2.3-9.57-5.89-9.57-5.89A22.28,22.28,0,0,0,121.54,120.45Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.16,148.13s-3.17-1.25-3.83-6.88V115.54l39.08-4.41Z"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "75.91 110.38 72.41 111.13 37.16 148.13 39.91 148.63 75.91 110.38"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.91 110.38 91.16 118.13 54.82 151.53 39.66 148.63 75.91 110.38"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "50.91 151.13 43.29 149.38 79.16 112.88 86.41 116.07 50.91 151.13"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "112.81 132.8 71.91 110.88 113.68 106.22 133.43 103.52 112.81 132.8"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "133.43 103.52 112.81 132.8 106.66 129.38 125.16 104.88 133.43 103.52"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M78.16,154.3s-3.83,1-4,6.5,4.75,17.16,1.92,26.33c0,0-.59-17.83-2.92-26.17S78.16,154.3,78.16,154.3Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M71.16,154.3s-3.83,1-4,6.5,4.33,17.16,1.5,26.33c0,0-.17-17.83-2.5-26.17S71.16,154.3,71.16,154.3Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M64.16,154.3s-3.83,1-4,6.5,4.92,17.16,2.08,26.33c0,0-.75-17.83-3.08-26.17S64.16,154.3,64.16,154.3Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M57.11,190.05S57.49,177,54.49,172s-6.31-13.57-1.32-17a12.09,12.09,0,0,0,1,12.45c3.47,5.18,6.58,15,4.42,22.84Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M81.23,117.51a4.88,4.88,0,0,1,.38-1.26c0-.1.1-.21.16-.31s.06-.14,0-.15,0,0,0,0,0,0,0,0-.31.13-.36.15a4.74,4.74,0,0,1-1.37.38c-1.26.16-2.42-.07-3.32.45a2.27,2.27,0,0,0-1.12,1.7,1.31,1.31,0,0,0,.33,1,1.37,1.37,0,0,0,1.26.34,2.1,2.1,0,0,0,.75-.31,1.61,1.61,0,0,0,0,2,1.26,1.26,0,0,0,1,.37,2.28,2.28,0,0,0,1.74-1.06C81.23,119.92,81,118.75,81.23,117.51Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M76.41,122.26a4.49,4.49,0,0,1,.37-1.26c0-.1.1-.21.16-.31s.07-.14,0-.15,0,0,0,0v0s-.31.13-.37.15a4.74,4.74,0,0,1-1.37.38c-1.25.16-2.42-.07-3.32.45a2.28,2.28,0,0,0-1.12,1.7,1.28,1.28,0,0,0,.34,1,1.34,1.34,0,0,0,1.25.34,2.22,2.22,0,0,0,.76-.31,1.61,1.61,0,0,0,0,2,1.28,1.28,0,0,0,1,.37,2.28,2.28,0,0,0,1.74-1.06C76.4,124.67,76.2,123.5,76.41,122.26Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M71.58,127a5.27,5.27,0,0,1,.37-1.26c0-.1.1-.21.16-.31s.07-.14.06-.15h0s0,0,0,0-.31.13-.36.15a4.8,4.8,0,0,1-1.38.38c-1.25.16-2.41-.07-3.32.45a2.27,2.27,0,0,0-1.11,1.7,1.27,1.27,0,0,0,.33,1,1.35,1.35,0,0,0,1.25.34,2.07,2.07,0,0,0,.76-.31,1.61,1.61,0,0,0,0,2,1.28,1.28,0,0,0,1,.37A2.31,2.31,0,0,0,71,130.31C71.57,129.42,71.38,128.25,71.58,127Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M66.75,131.76a4.7,4.7,0,0,1,.38-1.25,1.91,1.91,0,0,1,.16-.32c0-.09.06-.14,0-.15h0v0s-.31.13-.36.15a4.72,4.72,0,0,1-1.38.38c-1.25.16-2.41-.07-3.31.45a2.28,2.28,0,0,0-1.12,1.7,1.31,1.31,0,0,0,.33,1,1.36,1.36,0,0,0,1.26.34,2.27,2.27,0,0,0,.75-.3,1.61,1.61,0,0,0,0,2,1.29,1.29,0,0,0,1,.36,2.29,2.29,0,0,0,1.74-1.06C66.74,134.18,66.55,133,66.75,131.76Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M61.93,136.51a4.33,4.33,0,0,1,.37-1.25l.16-.32c0-.09.07-.13,0-.15h0v0c-.05,0-.31.13-.37.15a4.74,4.74,0,0,1-1.37.38c-1.25.16-2.42-.07-3.32.45a2.28,2.28,0,0,0-1.12,1.7,1.28,1.28,0,0,0,.34,1,1.34,1.34,0,0,0,1.25.34,2.41,2.41,0,0,0,.76-.3,1.61,1.61,0,0,0,0,2,1.3,1.3,0,0,0,1,.36,2.25,2.25,0,0,0,1.74-1.06C61.92,138.93,61.72,137.75,61.93,136.51Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M57.1,141.26a5.07,5.07,0,0,1,.37-1.25l.16-.32c0-.09.07-.13.06-.15h0v0s-.31.13-.37.15a4.65,4.65,0,0,1-1.37.38c-1.25.16-2.41-.07-3.32.45a2.25,2.25,0,0,0-1.11,1.7,1.26,1.26,0,0,0,.33,1,1.35,1.35,0,0,0,1.25.34,2.32,2.32,0,0,0,.76-.3,1.61,1.61,0,0,0,0,2,1.3,1.3,0,0,0,1,.36,2.25,2.25,0,0,0,1.74-1.06C57.09,143.68,56.9,142.5,57.1,141.26Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M52.27,146a4.7,4.7,0,0,1,.38-1.25,2.39,2.39,0,0,1,.16-.32c0-.09.06-.13,0-.15h0a0,0,0,0,0,0,0s-.31.13-.36.15a4.72,4.72,0,0,1-1.38.38c-1.25.16-2.41-.07-3.31.45a2.28,2.28,0,0,0-1.12,1.7,1.29,1.29,0,0,0,.33,1,1.39,1.39,0,0,0,1.26.33A2.27,2.27,0,0,0,49,148a1.59,1.59,0,0,0,0,2,1.28,1.28,0,0,0,1,.36,2.28,2.28,0,0,0,1.74-1.06C52.26,148.43,52.07,147.26,52.27,146Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M128.49,105.42a3.42,3.42,0,0,1,.1-.89c0-.08,0-.16.07-.24s0-.1,0-.11h0s-.19.12-.22.14a3.15,3.15,0,0,1-.87.41c-.81.25-1.6.22-2.14.67a1.57,1.57,0,0,0-.55,1.28.93.93,0,0,0,.34.66.88.88,0,0,0,.86.1,1.75,1.75,0,0,0,.47-.29,1.14,1.14,0,0,0,.2,1.37.84.84,0,0,0,.71.14,1.5,1.5,0,0,0,1-.92A6.61,6.61,0,0,0,128.49,105.42Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M125.83,109.19a3.5,3.5,0,0,1,.11-.89,2.17,2.17,0,0,1,.07-.24c0-.06,0-.1,0-.11h0s-.2.12-.23.14a3.23,3.23,0,0,1-.86.41c-.81.25-1.61.22-2.15.67a1.6,1.6,0,0,0-.54,1.29.86.86,0,0,0,.33.65.89.89,0,0,0,.87.1,1.58,1.58,0,0,0,.47-.29,1.12,1.12,0,0,0,.2,1.37.84.84,0,0,0,.71.14,1.55,1.55,0,0,0,1-.92A6.63,6.63,0,0,0,125.83,109.19Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M123.18,113a3.47,3.47,0,0,1,.1-.89c0-.08,0-.16.07-.24s0-.1,0-.1a0,0,0,0,0,0,0,0,0,0,0,0,0,0s-.19.12-.22.14a3.15,3.15,0,0,1-.87.41c-.81.25-1.6.22-2.14.67a1.57,1.57,0,0,0-.55,1.28.93.93,0,0,0,.34.66.87.87,0,0,0,.87.09,1.39,1.39,0,0,0,.46-.28,1.14,1.14,0,0,0,.2,1.37.85.85,0,0,0,.71.14,1.55,1.55,0,0,0,1-.91A6.69,6.69,0,0,0,123.18,113Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M120.52,116.73a3.5,3.5,0,0,1,.11-.89,2.17,2.17,0,0,1,.07-.24c0-.06,0-.1,0-.11h0s-.19.12-.23.14a2.84,2.84,0,0,1-.86.41c-.81.25-1.61.21-2.15.67a1.59,1.59,0,0,0-.54,1.28.92.92,0,0,0,.33.67.89.89,0,0,0,.87.08,1.54,1.54,0,0,0,.47-.28,1.13,1.13,0,0,0,.2,1.37.84.84,0,0,0,.71.14,1.51,1.51,0,0,0,1-.91A6.69,6.69,0,0,0,120.52,116.73Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M117.87,120.5a3.06,3.06,0,0,1,.11-.89,1.09,1.09,0,0,1,.07-.24c0-.06,0-.1,0-.1h0a0,0,0,0,0,0,0s-.19.12-.22.14a3.15,3.15,0,0,1-.87.41c-.8.25-1.6.22-2.14.67a1.53,1.53,0,0,0-.54,1.28.87.87,0,0,0,.33.66.89.89,0,0,0,.87.1,1.42,1.42,0,0,0,.46-.29,1.13,1.13,0,0,0,.21,1.37.86.86,0,0,0,.7.14,1.53,1.53,0,0,0,1-.91A6.69,6.69,0,0,0,117.87,120.5Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M115.22,124.27a3.08,3.08,0,0,1,.1-.89,2.17,2.17,0,0,1,.07-.24c0-.06,0-.1,0-.1s0,0,0,0v0s-.19.12-.23.14a3.09,3.09,0,0,1-.86.41c-.81.25-1.61.22-2.14.67a1.57,1.57,0,0,0-.55,1.28.92.92,0,0,0,.34.67.89.89,0,0,0,.86.09,1.34,1.34,0,0,0,.47-.3,1.14,1.14,0,0,0,.2,1.38.84.84,0,0,0,.71.14,1.5,1.5,0,0,0,1-.92A6.86,6.86,0,0,0,115.22,124.27Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M112.56,128a3.1,3.1,0,0,1,.11-.89,2.17,2.17,0,0,1,.07-.24c0-.06,0-.1,0-.1s0,0,0,0,0,0,0,0-.19.12-.22.14a3.23,3.23,0,0,1-.86.41c-.81.25-1.61.22-2.15.67a1.57,1.57,0,0,0-.54,1.29.84.84,0,0,0,1.2.75,1.62,1.62,0,0,0,.46-.29,1.13,1.13,0,0,0,.21,1.37.83.83,0,0,0,.7.14,1.53,1.53,0,0,0,1-.91A6.69,6.69,0,0,0,112.56,128Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M90.79,166l2-2.13-.13-3s-6.37-1.37-6.87-1.37c0,0-.5,2.62-.13,3.37S88.54,165.38,90.79,166Z"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "94.16 171.01 89.41 170.63 90.16 171.88 94.06 173.71 94.16 171.01"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.16 96.52 109.33 125.02 111.99 121.68 55.83 94.02 54.16 96.52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13H);
export default __webpack_public_path__ + "static/media/13_h.407674348698ee04878d34ee496452ae.svg";
export { ForwardRef as ReactComponent };